webpackJsonp([1],{

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4AD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f86d1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("7bK5")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9f86d1c4"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aafb8a92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("hRj/")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a05dab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("mw9Q")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0b1688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("J4AD")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fda002c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("ugbl")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "IOC - Marketing Report Paris 2024",
  "shortTitle": "",
  "description": "",
  "width": 620,
  "height": 877,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/paris2024",
  //  "basePath": "", 
  "companyLogo": "1-logo-1.png",
  "publishURL": "",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "subscribeEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/paris2024/static/_content/ioc-mr-paris-2024.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "International Olympic Committee  IOC MARKETING REPORT PARIS 2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "      \n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" style=\"top:244px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(10);\" style=\"top:268px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" style=\"top:294px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(26);\" style=\"top:318px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(40);\" style=\"top:344px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(80);\" style=\"top:368px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(90);\" style=\"top:394px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(96);\" style=\"top:418px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(102);\" style=\"top:444px; left:232px; width:376px; height:20px;\"></div> \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(112);\" style=\"top:468px; left:232px; width:376px; height:20px;\"></div> \n \n",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n         },1000)\n    }\n\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Contents  3  CONTENTS Forewords				  4  Games Wide Open			  10  Olympic Marketing Overview  22  Broadcasting				  26  Partnerships				  40  Digital Engagement			  80  Ticketing and Hospitality		  90  Licensing and Merchandising		  96  The Olympic Brand			  102  Acknowledgements			  112"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/jcB7QA5N7CE?si=bFndyE0zVs6Sd4RK')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:40px;top:260px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>    \n      \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“The Olympic Games are first and foremost about sport. As we have seen in Paris, they are also about so much more than sport.” Thomas Bach, President, International Olympic Committee"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "5  FOREWORD BY THOMAS BACh T  he Olympic Games Paris 2024 were truly Olympic Games of a new era. The first Olympic Games delivered fully under our Olympic Agenda reforms: younger, more urban, more inclusive, more sustainable. The first ever Olympic Games with full gender parity. A record 84 per cent of the potential global audience followed the Games. This equates to around five billion people and underlines the massive success of the Games in Paris. This record-breaking reach was made possible thanks to our Media RightsHolders, with more coverage made available and watched than ever before, in particular on digital and social media platforms, and the many activations of our Worldwide Olympic Partners. I would personally like to congratulate all of them on their outstanding contributions to the success of these Olympic Games. The IOC is proud and grateful to work together with such a dedicated community of commercial partners. Their commitment ensures the Olympic Games continue to inspire and unite globally. And beyond the Olympic Games, they fuel our mission to make the world a better place through sport. Paris 2024 came at the right time for the expectations of our world, with independent consumer research demonstrating that people believe the Olympic Movement’s mission to unite the world in peaceful competition is more important than ever in a divided world, and that the IOC was successful in this effort. Another landmark achievement is that the Olympic values truly resonate with younger generations, as our research shows. These values were on full display in the Olympic Village, where athletes from  the territories of 206 National Olympic Committees and the IOC Refugee Olympic Team lived peacefully together under one roof. They created a culture of peace, sending a powerful message across the globe. This message of togetherness, of joie de vivre – this message of peace: this is what people all around the world were longing for. But these Olympic Games could only inspire the world because our French hosts prepared the stage – and what an amazing stage it was. Millions of people celebrating the athletes in the streets of Paris and all across France. Millions of spectators in iconic venues creating an overwhelming atmosphere. More than half of the world’s population sharing in this spectacular showcase of the unity of humankind in all our diversity. The Olympic Games Paris 2024 were a celebration of the athletes and sport at its best. They were a remarkable celebration of the values we hold dear – excellence, solidarity and peace. The Olympic Games are first and foremost about sport. As we have seen in Paris, they are also about much so much more than sport. The partnerships with our Worldwide Olympic Partners and Media RightsHolders, which made all of this possible, are truly a perfect reflection of our Olympic motto: Faster, Higher, Stronger – Together.  Thomas Bach, President, International Olympic Committee"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/jcB7QA5N7CE?si=NcMOgCDmpM764oBc')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:60px;top:220px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“Paris 2024 was a collective project, a vision shared by the entire nation and only made possible by the commitment of our public and private teammates.” Tony Estanguet, President, Paris 2024 Organising Committee"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "7  FOREWORD BY Tony Estanguet T  his summer, France wrote a bold new chapter in the history of the Olympic and Paralympic Games. It was a season of remarkable records and emotions that will forever remain in the hearts of the French people and beyond. From the beginning, we aspired to make these Games different, to demonstrate that it is possible to organise Games that are both spectacular and responsible. Paris 2024 was a collective project, a vision shared by the entire nation and only made possible by the commitment of our public and private teammates. I would like to extend my sincere thanks to President Bach, the French Government, the City of Paris, the Île-de-France Region, the Métropole du Grand Paris and the Seine-SaintDenis department for their unwavering support and contributions throughout this journey. We are very grateful to the partners, official suppliers and licensees who were all vital to the delivery of the Games. And are very grateful to the broadcasters who were the key to sharing the stories of the competitions. Together, we showed the extraordinary achievements that become possible when we unite around a shared and bold set of ambitions. I would like to express my sincere thanks and gratitude to all the athletes of the Paris 2024 Olympic Games. They surpassed every expectation,  showing resilience, determination and the true spirit of Olympism. They are now part of the extraordinary legacy of these Games. To the fans, both in the venues and watching around the world, thank you! You created an atmosphere like no other, making these Games unforgettable for everyone involved. We worked hard to engage people with Paris 2024, whether digitally or in person, like never before. From our social media posts and the Opening Ceremony on the Seine, to the Mass Event Running and the Champions Park, we delivered on our vision of a Games Wide Open. A heartfelt thank you also goes to the 45,000 volunteers whose dedication, passion and tireless efforts brought these Games to life. Your contributions were the backbone of Paris 2024, and your commitment ensured that the Games were a success. To everyone who played a role in making Paris 2024 an extraordinary success, un grand merci.  Tony Estanguet, President, Paris 2024 Organising Committee"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“With record-breaking viewership across television, digital platforms and social media, Paris 2024 stands as the most followed Olympic Games in history.” Jiří Kejval, Chair IOC Marketing Commission"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "9  FOREWORD BY Jiří Kejval T  he Olympic Games Paris 2024 were truly historic, not only for the athletes but also for the global audience who followed this unforgettable event. More than half of the world’s population tuned in to experience the magic of these Games. With record-breaking viewership across television, digital platforms and social media, Paris 2024 stands as the most followed Olympic Games in history. This remarkable reach was made possible by the tireless efforts of our Media Rights-Holders and Olympic Broadcasting Services, who provided more comprehensive coverage than ever before. Whether on television, digital platforms or social media, fans had unprecedented access to the excitement and drama of the Games. The engagement across social platforms alone exceeded 12 billion, showcasing the vast global interest and bringing the Olympic spirit to younger and more diverse audiences. Our dedicated efforts to attract non-sport fans, particularly younger generations, through collaborations with influencers and athletes from various fields, further expanded our reach. A key driver of this success was the extraordinary support from our Worldwide Olympic Partners. Their contributions went far beyond traditional sponsorship. From technology and  infrastructure to innovative marketing campaigns, their presence could be felt everywhere – in the streets of Paris, the Olympic Village and across global markets. These partners were instrumental in staging the Games and promoting the Olympic values around the world. This Marketing Report highlights the achievements of our media and commercial partners, whose collaborative efforts not only helped make Paris 2024 a resounding success but also supported the development of sport worldwide. By redistributing 90 per cent of the revenue generated through our marketing programmes, the IOC continues to empower athletes and sports organisations globally. The Olympic Games Paris 2024 set a new standard for future Games, and we are deeply grateful to everyone who made this possible.  Jiří Kejval, Chair, IOC Marketing Commission"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Games Wide Open"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "      \n\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/vy6FivZHRjQ?si=LvZ9GGArVCxE3l6g')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:0px;top:70px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "12  Games Wide Open THE OLYMPIC GAMES PARIS 2024 SHOWCASED THE WORLD’S BEST ATHLETES AND THE UNIFYING POWER OF SPORT, WITH REMARKABLE ACHIEVEMENTS AND HISTORIC FIRSTS SET AGAINST THE ICONIC BACKDROPS OF THE VIBRANT HOST CITY The Olympic Games Paris 2024 brought the world together for 19 unforgettable days, showcasing remarkable achievements by athletes and the vibrant energy of the host nation. Set against the backdrop of one of the world’s most iconic cities, Paris 2024 lived up to its promise of delivering “Games Wide Open”, with historic performances, breathtaking venues and inspirational moments of unity and sportsmanship, leaving  a lasting impression on fans and athletes alike. The Games began with a spectacular Opening Ceremony on the River Seine, where athletes from the territories of 206 National Olympic Committees (NOCs) and the IOC Refugee Olympic Team paraded on boats against the stunning backdrop of Paris. This unique ceremony transformed the heart of the city into an Olympic stage, capturing the  “This was France completely in love with the Olympic Games. Millions on the streets of Paris, full venues everywhere and unrivalled atmosphere.” Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n      \n        <h1 id=\"13-no\" class=\"abs olympic-HeadlineReg 13-no\" style=\"top:220px;left:307px; font-size: 1.9em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 32 }' ></h1>\n        <h1 id=\"13-no\" class=\"abs olympic-HeadlineReg 13-no\" style=\"top:220px;left:407px; font-size: 1.9em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 329 }' ></h1>\n        <h1 id=\"13-no\" class=\"abs olympic-HeadlineReg 13-no\" style=\"top:220px;left:515px; font-size: 1.9em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 15 }' ></h1>\n\n        <img class=\"abs halfScaleC 13-no-1\" style=\"top:280px;left:234px;\" src=\"/paris2024/static/_content/13-no.png\"/>\n\n        <h1 id=\"13-no\" class=\"abs olympic-HeadlineReg 13-no\" style=\"top:320px;left:464px; font-size: 2.8em; font-weight: 300; color: #009641; padding: 0px; margin: 0px;\"  data-number='{\"to\": 206 }' ></h1>\n        <h1 id=\"13-no\" class=\"abs olympic-HeadlineReg 13-no\" style=\"top:448px;left:454px; font-size: 2.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20 }' ></h1>\n\n      \n      ",
    "script": "\n        function onPageEnter() {\n        pg13Anim = new TimelineMax();\n        pg13Anim.fromTo(cOf(\"13-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[0])}}, 1.0)\n        .fromTo(cOf(\"13-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[1])}}, 1.1)\n        .fromTo(cOf(\"13-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[2])}}, 1.2)\n        .fromTo(cOf(\"13-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[3])}}, 1.3)\n        .fromTo(cOf(\"13-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[4])}}, 1.4)\n        .fromTo(cOf(\"13-no-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.1);\n        }\n\n        function onPageLeave() {\n        pg13Anim.stop();\n        resetNumbers(\"13-no\");\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Games Wide Open  13  Paris 2024 in numbers  imagination of millions and setting the tone for Games defined by innovation and inclusivity. This groundbreaking approach saw Paris itself become a star of the Games, with its historic landmarks transformed into spectacular sporting venues. Archery took place at Les Invalides, beach volleyball unfolded beneath the Eiffel Tower, fencing lit up the Grand Palais, and equestrian events graced the grounds of the Château de Versailles. These iconic locations and many others provided awe-inspiring backdrops to the sporting action, seamlessly blending the city’s cultural heritage with the energy and excitement of the Olympic Games. In line with Paris 2024’s vision, these Games spread beyond Paris too, involving the whole of France. Sailing took place in Marseille, shooting in Châteauroux, some handball and basketball in Lille, and surfing in Tahiti, while football was shared between Lyon, Nantes, Bordeaux, Saint-Etienne, Nice, Marseille and Paris. And the performances of the athletes were no less breathtaking than the venues, with an array of extraordinary achievements, historic firsts and recordbreaking feats. French swimmer Léon Marchand and judoka Teddy Riner both became national icons with their multiple gold medals, uniting fans in spontaneous celebrations throughout the city. Simone Biles returned to the Olympic stage in stunning fashion, leading Team USA to gold in gymnastics and adding to her incredible legacy. Other sporting giants rose to the occasion as well. Serbian tennis star Novak Djokovic finally won the Olympic singles gold that had eluded him for four editions of the Games, while Katie Ledecky’s victory in the women’s 1,500m freestyle took her career total to nine Olympic gold medals in the pool, tying her with gymnast Larissa Latynina for the most Olympic titles won by a female athlete. Sweden’s Armand  32  Sports  50/50  329  15  medal events  Quota places were distributed equally between men and women, making Paris 2024 the first gender equal Olympic Games  new events Athletes from the territories of  206  NOCs + the IOC Refugee Olympic Team  20  mixed-gender events"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Global Games 91 NOCs and the IOC Refugee Olympic Team won medals 1st ever medal for the IOC Refugee Olympic Team Cindy Ngamba bronze, boxing, women’s 75kg  4 NOCs won their first Olympic Games gold medal  Botswana  Letsile Tebogo athletics, men’s 200m  Dominica  Thea LaFond athletics, women’s triple jump  Guatemala  Adriana Ruano shooting, women’s trap  Saint Lucia  Julien Alfred athletics, women’s 100m  4 NOCs won their first Olympic medals  Albania  Chermen Valiev bronze, wrestling, men’s 74kg freestyle  Cape Verde  David de Pina bronze, boxing, men’s 51kg  Dominica  Thea LaFond gold, athletics, women’s triple jump  Saint Lucia  Julien Alfred gold, athletics, women’s 100m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Games Wide Open  “I think that’s the beauty of the Olympics – you have such a multicultural and multinational crowd.” Novak Djokovic (SRB, tennis) 'Mondo' Duplantis, meanwhile, soared higher than any athlete in history at Paris 2024, winning gold in the men’s pole vault at an astounding 6.25m to break his own world record – one of 32 world records broken during the course of the Games. Paris 2024 provided plenty of historic firsts too, with four National Olympic Committees winning their first ever Olympic gold medals. From Saint Lucia’s Julien Alfred winning the women’s 100m and Thea LaFond’s victory in the triple jump for Dominica, to Letsile Tebogo of Botswana triumphing in the men’s 200m and Guatemalan shooter Adriana Ruano’s podium-topping performance in the women’s trap, these moments underscored the universality of the Games. Francisca Crovetto also wrote  15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      \n       <h1 id=\"16-no\" class=\"abs olympic-HeadlineCon 16-no\" style=\"top:533px;left:350px; font-size: 3em; font-weight: 300; color:#000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 95, \"append\" : \"%\"}' ></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n        pg16Anim = new TimelineMax()\n        pg16Anim.fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[0])}}, 1.0);\n        }\n\n        function onPageLeave() {\n        pg16Anim.stop();\n        resetNumbers(\"16-no\");\n        }\n      ",
    "searchText": "16  her name into the record books as she became the first female Olympic champion from Chile by winning the women’s skeet event, while Cuban Greco-Roman wrestling star Mijaín Lopez ended his career on a high, making history as the first athlete to win five consecutive gold medals.  Beyond the sporting highlights, moments of sportsmanship and unity defined Paris 2024. In a memorable display of the Olympic values, China’s He Bing Jiao consoled an injured Carolina Marín of Spain during the badminton semifinals, exemplifying the respect and camaraderie that the Games inspire.  But Paris 2024 wasn’t just about victories – these were also the first Olympic Games in history with full gender parity, thanks to the distribution of an equal number of quota places to female and male athletes by the IOC. That spirit of inclusion extended throughout the Games, with the Champions Park, at the foot of the Eiffel Tower, bringing fans closer to the action with parades for medal-winners, and the Marathon Pour Tous giving thousands of members of the public the chance to take part in marathon and 10km running events along the Olympic route in the heart of Paris.  In a similar vein, the IOC Refugee Olympic Team once again captured hearts, with 37 athletes competing across 12 sports, demonstrating the resilience and determination of individuals displaced by conflict. Their performances reminded the world of the transformative power of sport to provide hope and opportunity, with boxer Cindy Ngamba making history in the women’s 75kg event as she clinched bronze to win the IOC Refugee Olympic Team’s first ever medal.  Across France, six million people visited celebration sites, demonstrating the deep enthusiasm and support for the Games, while fans packed venues and lined the streets of Paris, creating an electric atmosphere that added to the magic of the competition.  “It just gives me the tingles and I think that’s the Olympics; it just gives you this energy you can’t find anywhere else.” Jessica Fox (AUS, canoe slalom)  3 out of 4 people believe the IOC was successful in 'bringing the world together in peaceful competition' at Paris 2024  The inclusion of surfing in Tahiti and urban sports in Paris’s dynamic settings also brought new energy to the Olympic programme, expanding its appeal and relevance. Breaking, making its Olympic debut, added a fresh cultural dimension to the event, appealing to younger audiences and bridging the gap between traditional sports and contemporary culture.  As the Games drew to a close, IOC President Thomas Bach captured the essence of the event, remarking that the athletes had helped 'to make the City of Light shine brighter than ever before', while it became clear that Paris 2024 had truly fulfilled its vision of “Games Wide Open”, uniting the world through sport and creating a truly inclusive and innovative celebration.  95%  of athletes surveyed rated their overall experience positively"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/xNJmh_QFukI?si=dHNX4xVTSrtN8dh7')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:510px;top:74px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:141px;left:55px; font-size: 3.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 590, \"preppend\": \"USD \", \"append\": \"M\" }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:253px;left:75px; font-size: 2.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 38, \"preppend\": \"USD \", \"append\": \"M\" }' ></h1>\n\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:322px;left:83px; font-size: 3.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1560, \"comma\": true }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:438px;left:103px; font-size: 3.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 74 }' ></h1>\n\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:141px;left:300px; font-size: 3.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 215 }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:236px;left:303px; font-size: 2.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 140 }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:322px;left:295px; font-size: 3.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 599 }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:474px;left:277px; font-size: 1.7em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 303 }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:474px;left:346px; font-size: 1.7em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 296 }' ></h1>\n\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:137px;left:465px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 75 }' ></h1>\n      <img class=\"abs halfScaleC 17-medal-1\" style=\"top:190px;left:487px;\" src=\"/paris2024/static/_content/17-gold-1.png\"/>\n      <img class=\"abs halfScaleC 17-medal-1\" style=\"top:226px;left:487px;\" src=\"/paris2024/static/_content/17-silver-1.png\"/>\n      <img class=\"abs halfScaleC 17-medal-1\" style=\"top:262px;left:487px;\" src=\"/paris2024/static/_content/17-bronze-1.png\"/>\n\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:326px;left:465px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 195 }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:403px;left:465px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1 }' ></h1>\n      <h1 id=\"17-no\" class=\"abs olympic-HeadlineCon 17-no\" style=\"top:484px;left:465px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5 }' ></h1>\n      <img class=\"abs halfScaleC 17-medal-2\" style=\"top:545px;left:487px;\" src=\"/paris2024/static/_content/17-gold-2.png\"/>\n      <img class=\"abs halfScaleC 17-medal-2\" style=\"top:580px;left:487px;\" src=\"/paris2024/static/_content/17-silver-2.png\"/>\n      <img class=\"abs halfScaleC 17-medal-2\" style=\"top:615px;left:487px;\" src=\"/paris2024/static/_content/17-bronze-2.png\"/>\n\n      ",
    "script": "\n       function onPageEnter() {\n       pg17Anim = new TimelineMax();\n       pg17Anim.fromTo(cOf(\"17-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[0])}}, 1.0)\n       .fromTo(cOf(\"17-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[1])}}, 1.1)\n       .fromTo(cOf(\"17-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[2])}}, 1.2)\n       .fromTo(cOf(\"17-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[3])}}, 1.3)\n       .fromTo(cOf(\"17-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[4])}}, 1.4)\n       .fromTo(cOf(\"17-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[5])}}, 1.5)\n       .fromTo(cOf(\"17-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[6])}}, 1.6)\n       .fromTo(cOf(\"17-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[7])}}, 1.7)\n       .fromTo(cOf(\"17-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[8])}}, 1.8)\n       .fromTo(cOf(\"17-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[9])}}, 1.9)\n       .staggerFromTo(cOf(\"17-medal-1\"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.1)\n       .fromTo(cOf(\"17-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[10])}}, 2.2)\n       .fromTo(cOf(\"17-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[11])}}, 2.3)\n       .fromTo(cOf(\"17-no\")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[12])}}, 2.3)\n       .staggerFromTo(cOf(\"17-medal-2\"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.8)\n\n\n        setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n        pg17Anim.stop();\n        resetNumbers(\"17-no\");\n     \n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Games Wide Open  17  Olympic Solidarity at Paris 2024  The Olympic Solidarity programme helped thousands of athletes qualify for and compete at the Games by providing crucial funding to cover training, equipment and other essential costs, leading to outstanding results.  USD 590m  invested in the Olympic cycle leading up to Paris 2024  USD 38m  75  215  teams from  26 gold  140  20 silver  directed into scholarships  NOCs in eight sports received Team Support Grants  1,560  599  athletes (843 men; 717 women) from 195 NOCs in 27 sports received scholarships for their training towards Paris 2024  74  refugee athletes from 24 host countries, representing 14 sports, received grants to support their efforts to qualify for Paris 2024  medals won by scholarship-holders  29 bronze  195  NOCs received Olympic Solidarity athlete scholarship funding for Paris 2024  Olympic Solidarity individual scholarship-holders competed at Paris 2024  1  medal and 3 diplomas won by Refugee Athlete Support Grant beneficiaries  303 men  296  5  women  medals won by teams who received Olympic Solidarity Team Support grants  3  gold  1  silver  1  bronze  For  2025 to 2028 there will be a  10% increase Olympic Solidarity Scholarship holder Arshad Nadeem threw an Olympic record of 92.97 metres to clinch gold in the men’s javelin, becoming the first Pakistani athlete to win an Olympic gold medal in an individual sport  to the Olympic Solidarity budget, taking it to a total of  USD 650m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18  “It’s an incredible honour to represent the United States on this global stage, especially in a moment that can bring the whole world together.” LeBron James (USA, basketball)  “Such an honour. I haven’t found the right words to describe my Olympic experience.” Simone Biles (USA, gymnastics)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Games Wide Open  19  “The Olympic Games, for me without a doubt, is the most important event in the world of sport.” Rafa Nadal (ESP, tennis)  “The energy here in Paris has been incredible.” Katie Ledecky (USA, swimming)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "20  “Absolutely amazing. It's honestly one of the best golf tournaments I've ever been involved in.” Rory McIlroy (IRL, golf)  “The crowd was what moved me the most.” Rayssa Leal (BRA, skateboarding)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Games Wide Open  21  “Nothing can describe my emotion.” Zheng Qinwen (CHN, tennis)  “I think these were the best Olympics ever, because of all the beautiful venues that perfectly represented France.” Antoine Dupont (FRA, rugby sevens)  “Paris 2024 has been an epic experience.” Beatrice Chebet (KEN, athletics)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Marketing Overview"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "24  Olympic Marketing Overview AS A NON-PROFIT ORGANISATION, THE INTERNATIONAL OLYMPIC COMMITTEE USES THE REVENUES GENERATED FROM THE OLYMPIC GAMES TO ASSIST ATHLETES AND DEVELOP SPORT WORLDWIDE. The Olympic Games generate substantial revenues that are almost unparalleled across the sporting world thanks to a range of marketing programmes that are coordinated by the International Olympic Committee (IOC).  These programmes not only help ensure the successful staging of the Olympic Games, but also assist athletes and develop sport worldwide, while promoting the Olympic values to a global audience.  These revenues are primarily generated by the IOC through three key streams: 1. Media Rights – Representing the largest portion of income, media rights ensure global broadcast coverage, allowing billions of people to experience the magic of the Games. 2. The Olympic Partner (TOP) Programme – As the highest level of sponsorship, the TOP Programme brings together leading multinational companies that provide essential financial resources, products and services for the Games. 3. Licensing and Merchandising – Through the sale of official Olympic products, fans can connect with the Games by purchasing licensed memorabilia, from apparel to souvenirs."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n\n      <h1 id=\"25-no\" class=\"abs olympic-HeadlineReg 25-no\" style=\"top:101px;left:438px; font-size: 2.7em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 7.6, \"decimals\": 1, \"preppend\": \"USD \", \"append\": \"BN\"}' ></h1>\n\n      <h1 id=\"25-no\" class=\"abs olympic-HeadlineCon 25-no\" style=\"top:156px;left:461px; font-size: 1.4em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4, \"append\": \"%\"}' ></h1>\n      <h1 id=\"25-no\" class=\"abs olympic-HeadlineCon 25-no\" style=\"top:156px;left:541px; font-size: 1.4em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5, \"append\": \"%\"}' ></h1>\n      <h1 id=\"25-no\" class=\"abs olympic-HeadlineCon 25-no\" style=\"top:357px;left:452px; font-size: 1.4em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30, \"append\": \"%\"}' ></h1>\n      <h1 id=\"25-no\" class=\"abs olympic-HeadlineCon 25-no\" style=\"top:357px;left:554px; font-size: 1.4em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 61, \"append\": \"%\"}' ></h1>\n\n      <h1 id=\"25-no\" class=\"abs olympic-HeadlineCon 25-no\" style=\"top:493px;left:484px; font-size: 2.9em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 90, \"append\": \"%\"}' ></h1>\n      <h1 id=\"25-no\" class=\"abs olympic-HeadlineCon 25-no\" style=\"top:779px;left:484px; font-size: 2.9em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10, \"append\": \"%\"}' ></h1>\n\n\n      \n      ",
    "script": "\n        function onPageEnter() {\n        pg25Anim = new TimelineMax();\n        pg25Anim.fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0])}}, 1.0)\n        .fromTo(cOf(\"25-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[1])}}, 1.2)\n        .fromTo(cOf(\"25-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[2])}}, 1.3)\n        .fromTo(cOf(\"25-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[3])}}, 1.4)\n        .fromTo(cOf(\"25-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[4])}}, 1.5)\n        .fromTo(cOf(\"25-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[5])}}, 1.6)\n        .fromTo(cOf(\"25-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[6])}}, 1.6)\n        }\n\n        function onPageLeave() {\n        pg25Anim.stop();\n        resetNumbers(\"25-no\");\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Marketing Overview  In total, through the sale of broadcasting and marketing rights, as well as other income streams, the revenue for the Olympiad that spanned 2017 to 2020/21 was USD 7.6 billion. This revenue is distributed across the Olympic Movement to support athletes, National Olympic Committees (NOCs), International Federations (IFs) and other Olympic stakeholders.  25  Olympic Revenue Sources  USD 7.6BN 4%  Other revenue  5%  Other rights  In total, the IOC redistributes 90 per cent of its income, ensuring that every day, USD 4.2 million is allocated to sports development worldwide. This funding supports the staging of the Games, assists smaller nations in developing their sporting programmes, and ensures that athletes have the resources they need to achieve their best.  30%  TOP Programme marketing rights  61%  Media rights  *Based on IOC’s audited financial statements for 2017-2020/21  Where the revenue goes  90%  Individual athletes and coaches, via Olympic Solidarity funding National Olympic Committees (NOCs), which prepare athletes and teams to compete in the Olympic Games International Sports Federations (IFs), which run and oversee the development of their sports around the world Organising Committees for the Olympic Games (OCOGs), which are in charge of staging the Olympic Games Other Olympic Movement and sport organisations to promote the worldwide development of sport  10%  IOC activities to develop sport and operations of the IOC"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Broadcasting"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        resetNumbers(\"29-no\");\n        }\n      ",
    "searchText": "28  Olympic Games Paris 2024:  the most followed Games ever  Australian swimmers Mollie O’Callaghan (left) and Ariarne Titmus (right) embrace after winning gold and silver respectively in the women’s 200m freestyle"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"29-no\" class=\"abs olympic-HeadlineCon 29-no\" style=\"top:98px;left:168px; font-size: 4.5em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 84, \"append\": \"%\"}' ></h1>\n\n      <img class=\"abs halfScaleC 29-text\" style=\"top:366px;left:23px;\" src=\"/paris2024/static/_content/29-no.png\"/>\n      <img class=\"abs halfScaleC 29-text\" style=\"top:455px;left:-6px;\" src=\"/paris2024/static/_content/29-no-2.png\"/>\n\n      <h1 id=\"29-no\" class=\"abs olympic-HeadlineCon 29-no\" style=\"top:467px;left:360px; font-size: 3.2em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 95, \"append\": \"%\"}' ></h1>\n      <h1 id=\"29-no\" class=\"abs olympic-HeadlineCon 29-no\" style=\"top:593px;left:360px; font-size: 3.2em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 70, \"append\": \"%\"}' ></h1>\n      <h1 id=\"29-no\" class=\"abs olympic-HeadlineCon 29-no\" style=\"top:746px;left:86px; font-size: 3.2em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 308741, \"comma\": true }' ></h1>\n      <h1 id=\"29-no\" class=\"abs olympic-HeadlineCon 29-no\" style=\"top:746px;left:374px; font-size: 3.2em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 178002, \"comma\": true }' ></h1>\n      \n      \n      ",
    "script": "\n        function onPageEnter() {\n        pg29Anim = new TimelineMax();\n        pg29Anim.fromTo(cOf(\"29-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[0])}}, 1.0)\n        .fromTo(cOf(\"29-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[1])}}, 1.4)\n        .fromTo(cOf(\"29-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[2])}}, 1.5)\n        .fromTo(cOf(\"29-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[3])}}, 1.6)\n        .fromTo(cOf(\"29-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[4])}}, 1.7)\n        .staggerFromTo(cOf(\"29-text\"), 0.6, {opacity:0, x:-20}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1.3)\n        }\n\n        function onPageLeave() {\n        pg29Anim.stop();\n        resetNumbers(\"29-no\");\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Broadcasting  84%  A record  of the potential global audience followed the Games*  29  This equals around  5 billion people Or more than half the world’s population  There were  13X more  engagements on the social media handles of Media Rights-Holders (MRHs) than there were for Tokyo 2020  There was a  25% increase  in the amount of coverage watched with 28.7 billion hours of footage viewed around the world on MRH platforms  This meant every viewer watched on average 9 hours of coverage, a 20% increase on the previous Games  In the home market of France,  95%  of the potential audience watched an average of 24 hours of coverage  70%  of the global audience watched on both television and digital platforms  Paris 2024 generated more coverage on MRH platforms than ever before  308,741 hours  178,002 hours  of digital coverage (Up 42% from Tokyo 2020)  of linear TV coverage (Up 18% from Tokyo 2020)  *Potential global audience with access to follow the Olympic Games and over the age of four years old."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "30  Broadcasting THE OLYMPIC GAMES PARIS 2024 MARKED A NEW MILESTONE IN OLYMPIC BROADCASTING, ACHIEVING UNPRECEDENTED GLOBAL REACH AND ENGAGEMENT  “Paris 2024 demonstrated the unprecedented global appeal of the Olympic Games. Working with our Media Rights-Holder partners, more coverage was made available and watched than ever, in particular on digital and social media platforms.” Thomas Bach, IOC President A record 84 per cent of the potential global audience* followed the Olympic Games Paris 2024, according to independent research conducted on behalf of the IOC. This equals around five billion people and means that more than half of the world’s population followed the inspirational achievements of the Olympic athletes and the magic of the Olympic Games, underlining the massive success of the Games in Paris. Media Rights-Holders (MRHs) delivered record results, driven in large part by increased visibility on digital channels. Globally, there were 13 times more social media engagements on MRH handles than for Tokyo 2020. Some 70 per cent of the global audience watched on both television and digital platforms, with MRHs offering more coverage on more platforms than ever before. There was a 25 per cent increase in the amount of coverage watched, with 28.7 billion hours of footage viewed around the world on MRH platforms. This meant every viewer watched on average nine hours of coverage, a 20 per cent increase on the previous Games. In the home market of France, 95 per cent of the potential audience watched an average of 24 hours of coverage of the Olympic Games.  An OBS camera operator captures former world champion skateboarder Gustavo Ribeiro (POR) in action in Paris  Record Coverage and Global Reach As the host broadcaster for the Olympic Games, Olympic Broadcasting Services (OBS) produced a record 11,000 hours of content for Paris 2024, surpassing any previous Games. This included 3,575 hours of live sports, ceremonies and Champions Park coverage, and represented a 15.8 per cent increase compared to the Olympic Games Tokyo 2020, enabling MRHs to deliver comprehensive, live coverage around the world across all platforms. As a result, global audiences experienced unprecedented access to the Games, with traditional TV and digital streaming providing deeper and more interactive engagement than ever before.  Athlete-Centric Coverage “I have been watching the Olympic Games on television ever since I was able to, so it is a special feeling to live them here, in Paris.” Lucas Corvee (FRA), badminton  Paris 2024 continued OBS’s tradition of innovation, enhancing the viewer experience through even more immersive storytelling and the use of cutting-edge technology. OBS was committed to delivering innovative coverage that not only  captured the essence of Olympic excellence but also immersed global audiences in the Olympic journey and the personal stories of their favourite athletes. With more athlete-centric and behind-the-scenes coverage, OBS brought the athletes’ stories to the forefront, helping broadcasters deepen viewers' understanding of the sport and foster greater engagement. Technological innovations also played a key role in elevating broadcast coverage to new levels. Cinematic lenses with a shallow depth of field created a more intimate and immersive experience, while a wide array of new data-driven graphics provided real-time, detailed insights into athletes’ performances. Viewers also enjoyed more multi-angle camera replays, offering previously unseen perspectives that fully immersed fans in the action. Additionally, the expanded use of ‘Athlete Moments’ featured emotional, virtual family reunions in post-competition coverage, bringing audiences worldwide closer to the adrenaline, emotion and spirit of the occasion after the athletes walked off the fields of play.  *Potential global audience with access to follow the Olympic Games and over the age of 4 years old"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:95px;left:40px;width:345px;height:28px\">\n      <a href=\"https://www.obs.tv/news/821\" target=\"_blank\"></a>\n      </div>\n\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:193px;left:75px; font-size: 3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11000, \"comma\": true, \"append\": \"+\"}' ></h1>\n\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:227px;left:251px; font-size: 1.5em; font-weight: 300; color: #fffefe; padding: 0px; margin: 0px;\"  data-number='{\"to\": 182}' ></h1>\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:227px;left:372px; font-size: 1.5em; font-weight: 300; color: #fffefe; padding: 0px; margin: 0px;\"  data-number='{\"to\": 8300, \"comma\": true, \"append\": \"+\"}' ></h1>\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:366px;left:254px; font-size: 1.5em; font-weight: 300; color: #fffefe; padding: 0px; margin: 0px;\"  data-number='{\"to\": 36}' ></h1>\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:363px;left:377px; font-size: 1.5em; font-weight: 300; color: #fffefe; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1200, \"comma\": true}' ></h1>\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:367px;left:503px; font-size: 1.5em; font-weight: 300; color: #fffefe; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3680, \"comma\": true, \"append\": \"+\"}' ></h1>\n\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:89px;left:498px; font-size: 2.2em; font-weight: 300; color: #fffefe; padding: 0px; margin: 0px;\"  data-number='{\"to\": 19000, \"comma\": true}' ></h1>\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:199px;left:487px; font-size: 2.2em; font-weight: 300; color: #fffefe; padding: 0px; margin: 0px;\"  data-number='{\"to\": 100000, \"comma\": true, \"append\": \"+\"}' ></h1>\n\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:345px;left:103px; font-size: 2.2em; font-weight: 300; color: #f8af00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 499}' ></h1>\n      <h1 id=\"31-no\" class=\"abs olympic-HeadlineCon 31-no\" style=\"top:411px;left:109px; font-size: 2.2em; font-weight: 300; color: #f8af00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 72}' ></h1>\n\n\n      \n      ",
    "script": "\n        function onPageEnter() {\n        pg31Anim = new TimelineMax();\n        pg31Anim.fromTo(cOf(\"31-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[0])}}, 1.0)\n        pg31Anim.fromTo(cOf(\"31-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[1])}}, 1.1)\n        pg31Anim.fromTo(cOf(\"31-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[2])}}, 1.2)\n        pg31Anim.fromTo(cOf(\"31-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[3])}}, 1.3)\n        pg31Anim.fromTo(cOf(\"31-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[4])}}, 1.4)\n        pg31Anim.fromTo(cOf(\"31-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[5])}}, 1.5)\n        pg31Anim.fromTo(cOf(\"31-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[6])}}, 1.6)\n        pg31Anim.fromTo(cOf(\"31-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[7])}}, 1.7)\n        pg31Anim.fromTo(cOf(\"31-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[8])}}, 1.2)\n        pg31Anim.fromTo(cOf(\"31-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[9])}}, 1.3)\n      \n         setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n        pg31Anim.stop();\n        resetNumbers(\"31-no\");\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Broadcasting  31  How the Games were broadcast  19,000  pieces of content made available to MRHs via OBS's cloud-based content delivery platform  11,000+ hours of content produced by OBS  499  Athlete Moments completed  72  182  broadcast sublicensees  36  Media Rights-Holders (including the Olympic Channel)  NOCs engaged through the Athlete Moment initiative  Grant Holloway (USA) uses the Athlete Moment to celebrate with friends and family after winning gold in the men's 110m hurdles  8,300+ broadcast personnel  1,200  OBS cameras  100,000+ highlight clips created automatically by AI  3,680+  microphones"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "32  A New Era of Broadcast Technology Paris 2024 marked a transformative milestone in broadcast technology, with Artificial Intelligence (AI) showcasing its unparalleled capability to analyse live data at speeds beyond human capacity, setting new benchmarks in Olympic coverage. AI played a crucial role in optimising broadcast operations, driving content creation and delivering data in innovative ways. Multi-camera replay systems powered by cloud-based AI and deep learning generated 3D models and texture mappings to offer unprecedented insights into the intricacies of each performance. Other advancements included AI-driven motion tracking and intelligent stroboscopic analysis, which provided broadcasters and audiences with real-time data visualisations and insights into athletes’ performances.  For the first time, specific applications featured real-time trajectory analysis for archery, enhanced data graphics for diving, serve reaction time for tennis, and ball spin detection for table tennis. OBS also introduced Automatic Highlights Generation, enabling MRHs to curate personalised highlight reels across 14 sports/disciplines based on their preferences. In addition, OBS Cloud, first introduced at Tokyo 2020, played a crucial role once again, enabling MRHs to streamline their operations and deliver content more efficiently. This cloud-based solution, developed in collaboration with Worldwide Olympic Partner Alibaba, allowed broadcasters to operate remotely, reducing the Games' broadcast footprint and improving flexibility and scalability in broadcast operations. OBS also partnered with Worldwide Olympic Partner Intel to develop a  “We aimed to bring viewers closer to the action and emotions of the Games, enhancing their experience and fostering a stronger connection with the athletes and the Olympic spirit.” Yiannis Exarchos, CEO, OBS more flexible and modular production environment, enabling OBS to deploy next-generation, virtualised production units for live coverage for the first time in an Olympic Games. The continued integration of these technologies ensured that Paris 2024 was not only the most-followed Games but also one of the most technologically advanced, establishing new standards for efficiency and sustainability in the broadcast industry."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Broadcasting  33  Expanding the Reach of Paris 2024 Paris 2024 showcased innovative partnerships and groundbreaking collaborations that elevated the Games to new heights, engaging diverse audiences worldwide:  Host Country Engagement: France Télévisions, in collaboration with the Paris 2024 Organising Committee, created programming that brought the Olympic spirit into the homes of millions. Initiatives included the daily programme Au Jeux Citoyens, which aired for over a year leading up to the Games, and the nationally celebrated arrival of the Olympic Flame in Marseille, which kicked off the Olympic Torch Relay through mainland France and overseas territories.  Gaming Innovations: The IOC and Visa partnered to launch Olympic World on Roblox, introducing the Olympic spirit to younger audiences. With over 11.1 million visits in just 14 days, it became the most successful sports property on the platform, demonstrating the power of gaming in engaging new fans.  Social and Creator Collaborations: Paris 2024 featured the first-ever Olympic Creator Programme, developed in collaboration with MRHs, Meta, YouTube and TikTok. The programme invited more than 100 leading digital creators from around the world to experience the Games and share their unique experiences via social media, helping to promote Paris 2024 coverage. Official broadcasters like NBC in the USA and Warner Bros. Discovery in Europe also partnered with social platforms and celebrities to amplify their reach.  Content Partnerships: The IOC’s collaboration with Netflix delivered Simon Biles Rising and Sprint, two docuseries that featured in Netflix’s global Top 10 and generated pre-Games anticipation. A third documentary series on the Olympic basketball tournament will be released in 2025, further extending the storytelling journey.  Through these diverse initiatives, Paris 2024 achieved unparalleled global reach, bringing the Games to life for fans of all ages and interests."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "34  Global Audience Highlights France  The Opening Ceremony achieved the highest audience in the history of French television, with an average of  24.4 million viewers  France Télévisions was watched by almost  60 million  94%  French viewers  Léon Marchand (FRA, swimming)  On average, a French person (4+) watched more than  24 hours  of the French population aged 4+ watched the Games  Peak audience of  of the event  france.tv generated more than  200 million views over the course of the Games  1 billion  views for clips published on France Télévisions’ social media pages  Europe  4x400m mixed relay team (NED, athletics)  Cumulative reach of more than  More than  215 million  in Europe viewing Olympics content on Warner Bros. Discovery’s platforms – 23% more than Olympic Games Tokyo 2020  viewers during Léon Marchand’s fourth gold medal win  Warner Bros. Discovery’s average linear television audiences for Paris 2024 were double those of Tokyo 2020  “Paris 2024 has again demonstrated the value of bringing premium sport and entertainment together to drive audience and engagement at scale.” 	 Andrew Georgiou, President and Managing Director, Warner Bros. Discovery UK & Ireland and WBD Sports Europe  15 million  5.2 billion  More than  7 billion  minutes streamed over the course of the Games – six times more than Tokyo 2020  video views of Warner Bros. Discovery Olympics posts on social media – ten times more than Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Broadcasting  35  USA  Paris 2024 content registered a record  “The Olympics reestablished their unique power to reassemble the American media audience.”  6.55 billion  Napheesa Collier (USA, basketball)  impressions across NBC Sports social channels – a 184% increase compared with Tokyo 2020  	 Gary Zenkel, President, NBC Olympics  Total Audience Delivery (TAD) of  Olympic coverage reached  30.6 million  152  viewers across the combined live Paris Prime and U.S. primetime periods – up 82% from Tokyo 2020  Led by Peacock,  23.5 billion  consecutive summer Olympic nights as the primetime no.1 show  minutes of Paris 2024 coverage was streamed – up 40% from all prior Summer and Winter Games combined  Great Britain “These figures across digital, linear, online and audio demonstrate that BBC Sport’s unique multiplatform offer is capable of uniting the nation with the very best of British storytelling.”  Keely Hodgkinson (GBR, athletics)  Keely Hodgkinson's gold medal in the women’s 800m final was the most watched event with  9.1 million viewers on BBC One and BBC iPlayer  	 Alex Kay-Jelski, Director of BBC Sport  36.1 million  BBC Sport's coverage of Paris 2024 was streamed a record-breaking  218 million  times online – more than double the 104 million streams recorded during the Olympic Games Tokyo 2020  viewers watched 15 minutes or more of the Paris Olympics on BBC TV - equivalent to 59% of the UK population"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "36  Australia  The dominance of Nine’s Olympics coverage led to 9News recording its 10 highest rating bulletins of the year during Paris 2024  “The Olympics are more than just a sporting event. They're a cultural phenomenon that resonates deeply with Australians from all walks of life. They unite the nation in a way that few other events can, bringing together millions of viewers across the country.” 	 Michael Healy, Director of Television, Nine Jessica Fox (AUS, canoe slalom)  A national total TV reach of  Nine’s coverage was broadcast to a national total television reach of  19.5 million  people across Channel 9, 9Gem and 9Now  5.6 million  9Now achieved a 16% incremental reach, with  2.7 million  viewers tuning in exclusively to the Olympics through 9Now out of an overall national reach of 7.5m on Australia’s no. 1 commercial freeto-air streaming platform  Canada  Skylar Park (CAN, taekwondo)  “Canadians shared in the excitement of Canada’s spectacular athletes — their incredible triumphs as well as their disappointments. The sense of pride they inspired in us lifted us all — it’s why the Olympics matter and why, as Canada’s national public broadcaster, we are so proud to bring them to Canadians, from coast to coast to coast.” 	 Catherine Tait, President and CEO, CBC/Radio-Canada  viewers aged 16-39 tuned into the broadcast, in the crucial demographic of people aged 25-54, more than 8.1m viewers tuned into Nine’s coverage of Paris 2024  Canadians consumed a record-breaking  7 in 10  Canadians (27m) tuned in for CBC/Radio-Canada's coverage of Paris 2024  24.3 million  hours of Paris 2024 content on CBC/Radio-Canada’s digital and streaming platforms, an increase of 170% over Tokyo 2020 and 121% over Beijing 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Broadcasting  37  Brazil Eduarda Santos Lisboa and Ana Patricia Silva Ramos (BRA, beach volleyball)  140.4 million reached with Globo’s Paris 2024 coverage across TV Globo, SporTV and GloboPlay  5 billion videos views  81%  of households reached by TV Globo, with TV ratings up 10% compared with Tokyo 2020  An innovative media rights deal with LiveMode (CazéTV) resulted in an audience of 56m people reached on its YouTube channel, with over 4.8m concurrent viewers for the women’s football final and women’s volleyball bronze medal game. More than 127m people were also reached on Instagram, and overall there were over  SporTV attracted an audience three times greater than all other pay TV channels on Olympic days  Germany  Double the streaming reach and consumption on Globoplay compared with Tokyo 2020  On the ZDFMediathek digital platform, on the days when the Games were broadcast on ZDF, an average of  9.93 million  ARD & ZDF reached  visits per day were achieved, up 62% compared with Tokyo 2020  53.4 million  viewers with their television broadcasts, representing around two thirds of the population Nelvie Raman Tiafack (GER, boxing)  ARD-ZDF digital offerings had recorded  The most successful Olympic broadcast on Das Erste was the coverage of the Opening Ceremony, which averaged  10.44 million  viewers over four hours, with a market share of 45.5%. This made it the most watched broadcast of the Olympic Games in 20 years  225 million  The audience share of ZDF’s Closing Ceremony coverage was  40.5%  with its Paris 2024 broadcast reaching 52% of the potential audience across the event  visits by the final Saturday, recording 65m hours of consumption"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "38  Japan  TVer, the streaming service of commercial broadcasters, had record numbers, with approximately  21 million  More than  105 million  Kagami Yuka (JPN, wrestling)  Japanese people watched some coverage of Paris 2024 across the Japanese Consortium’s TV channels, representing almost 90% of the potential viewers  CHina  Digital coverage reached over  31 billion  video views across CCTV's Yangshipin streaming service, CCTV News and the CCTV Sports app, all setting new standards  CCTV's national network audience share reached  35.75%  during the Games, an increase of 27% over the same number of days before the Opening Ceremony  The highest single-day audience share of the CCTV channel group reached  CCTV News had  13.19 billion Men’s team (CHN, table tennis)  38.33%  setting a new record for single-day audience share outside of key holidays (Spring Festival, Lantern Festival and National Day) since August 2016  people using the service, and the total number of views exceeding 110m. The total playback time reached 23m hours  As the main live broadcast channel for the event, CCTV-5 maintained the top spot in audience share on both networks during the Olympics, with an average national network share of  11.72%  the highest in the past five Olympic Games and an increase of 12% over the previous Olympic Games  video views, while CCTV Sports app had almost 17 times more daily visiting users than before the Games. CCTV Sports had 3.4bn views, with the majority (2.6bn) on live streams  CCTV's Yangshipin streaming service received  14.5 billion  video views, setting new historical records, with the daily average reaching twice that of Tokyo 2020. The app also topped the overall list of app downloads for 16 consecutive days. On social media, the apps' accounts recorded over 6.1bn videos views, with short content representing half of those"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Broadcasting  39  “70 per cent of the global audience watched on both television and digital platforms, with our Media Rights-Holding Partners offering more coverage on more platforms than ever before.” Anne-Sophie Voumard, Managing Director, IOC Television and Marketing Services  India  The network reported  2.6  Neeraj Chopra (IND, athletics)  times more advertising revenues than previous Games, using innovative ad assets  170 million  watched across Viacom18 platforms including JioCinema and Sport18 TV channels, with broadcast commentary in multiple local languages  Over  5 billion  minutes of consumption were recorded across these platforms  New Zealand Sky’s digital platforms, Sky Sport Now and Sky Go, also experienced significant volumes of activity during the Games as more than  Additionally, Sky’s social channels achieved strong engagement across YouTube, X, TikTok, Facebook, and Instagram throughout the Games. More than  1,200 posts  Ellesse Andrews (NZL, track cycling)  – at an average of over 42 daily posts – showcasing medalwinning performances, exclusive interviews and other highlights of the Games led to 44.8m impressions, 32.7m video views, 2.9m engagements and an audience growth of 35,000  350,000  unique viewers flocked to both platforms to stream Sky’s Olympics coverage almost 21m times, averaging 1.3m daily streams A total of  2.8 million  people – 57% of New Zealand’s population – watched the Olympic Games, including free-to-air on Sky Open, at an average of 1.4m viewers per day"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Partnerships"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      \n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/RTOpPFJxNBo?si=UShk4ZUYz2hQTZkT')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:20px;top:50px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n\n      ",
    "script": "\n       function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "42  Olympic Partnerships THE WORLDWIDE OLYMPIC PARTNERS TOOK THEIR SUPPORT FOR THE OLYMPIC MOVEMENT TO NEW HEIGHTS AT THE OLYMPIC GAMES PARIS 2024, PROVIDING CRUCIAL PRODUCTS, TECHNOLOGY AND SERVICES THAT MADE THE GAMES A SUCCESS The success of the Olympic Games Paris 2024 was made possible in large part by the unwavering support of the Worldwide Olympic Partners. As members of The Olympic Partners (TOP) Programme, these leading multinational companies played a vital role in ensuring the smooth running of the Games by providing essential products, services, technology and expertise. Their contributions supported almost every aspect of the Games, from day-to-day operations at competition venues to the support provided to athletes from around the world. Launched by the IOC in 1985, the TOP Programme has become the leading sports sponsorship programme in the world, offering exclusive global marketing rights within specific product categories. Over the years, the programme has not only generated crucial funding for the Olympic Movement but also enabled  the development of groundbreaking innovations that continue to enhance the Olympic experience for athletes and fans alike.  Olympic values and celebrated the achievements of the athletes, further increasing global engagement with the Games  For Paris 2024, the TOP Partners once again demonstrated their integral role in the successful staging of the Games. Their partnerships helped ensure that more athletes from more National Olympic Committees (NOCs) could compete on the world’s biggest stage, while also providing the financial security that allows the Olympic Movement to thrive. With 90 per cent of IOC revenue redistributed to support sport worldwide, the contributions of the TOP Partners benefit athletes and organisations at all levels, from grassroots initiatives to Olympic teams.  The following pages showcase the invaluable contributions that the TOP Partners made to the Olympic Games and how their support helped ensure the success of Paris 2024.  In addition to their direct impact on the Games, the TOP Partners ran global marketing campaigns that promoted the  “Without the support of our Worldwide Olympic Partners, without their technology, expertise, people, services, products and financing, the Olympic Games would simply not be possible.” Jiri Kejval, Chair, IOC Revenues and  Commercial Partnerships Commission"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n       function onPageEnter() {\n    }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  43  How the TOP Partners supported Paris 2024  $ Financial support, with revenues from the TOP Programme being redistributed to Olympic teams and the Paris 2024 Organising Committee  Essential products, services and expertise to ensure smooth Games-time operations  Initiatives to support participating athletes  Global marketing campaigns to promote the Olympic Games and celebrate the athletes  Unique Games-time experiences to enhance fan engagement"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/rsx_-hTMciU?si=vR-FXoqm2G7VocHF')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:15px;top:580px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n\n      ",
    "script": "\n       function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "44  AB InBev “AB InBev is proud to be the first global beer sponsor for the Olympic Games. Beer and sports are better together, and with no-alcohol Corona Cero leading the way, we offered Olympic fans more choices as they cheered on their favourite athletes and teams going for gold.” Michel Doukeris, CEO, AB InBev  Fact BOX  Exclusive category: Beer (alcohol and no-alcohol varieties) Member of the TOP Programme since: 2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:230px;left:230px;width:150px;height:18px\">\n      <a href=\"https://www.youtube.com/watch?v=DyREX8ZQswk&t=1s\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n       function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n         },1000)   \n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  45  For centuries, beer and sports have brought people together to create friendships, connections and unforgettable experiences. AB InBev, the world’s leading brewer, built on that legacy in 2024 by becoming a Worldwide Olympic Partner and choosing a no-alcohol beer, Corona Cero, as the first global beer sponsor of the Olympic and Paralympic Games.  alcohol beer with no-alcohol beer, like Corona Cero.  Sports are a strong force for positive change and AB InBev brands have a long history of award-winning and responsible sports marketing. During the Olympic Games Paris 2024, Corona Cero reached Olympic fans around the world with messages of connection, moderation and celebration. Together with the IOC, AB InBev highlighted a shared commitment to responsible consumption.  In addition, AB InBev hosted the Corona Cero Relaxation Lounge in the Olympic Village, providing a space for athletes to unwind and connect.  This included giving fans more ways to responsibly celebrate the Games by providing clear and actionable tips to consumers of legal drinking age, including eating before and while drinking; never drinking and driving; and alternating  1,000+  bartenders/servers trained globally in Responsible Beverage Service (RBS) as part of Smart Drinking efforts.  11  Golden Venues across 4 continents using the same seats as from the Olympic Games venues in iconic sunset destinations.  5,000+  limited-edition Corona Cero Golden Bottles gifted to Olympians at the Olympic Village  Hundreds of servers, staff and hospitality management worldwide were also trained and certified in responsible beverage service (RBS) to help prevent sales to minors, identify and address signs of impairment and prevent drunk driving.  For Every Golden Moment Activated in more than 40 markets globally, Corona Cero’s “For Every Golden Moment” platform invited the world to get outside and reconnect with nature – a theme that brings a fresh perspective of relaxation and celebration to the Olympic Games. By highlighting the emotion of golden moments from Olympians at the Games, the platform drew parallels with golden moments experienced by everyone in their daily lives, such as a beautiful sunset. From breaking records to raising a glass of golden beer to cheer on your favourite team, the platform aimed to remind consumers of the power of these meaningful moments.  With its Golden Venues activation, Corona Cero also brought the same seats as from the Olympic Games venues in Paris to iconic sunset destinations across four continents. The locations were selected for their remarkable sunsets, scenic beauty, and cultural significance, offering visitors a unique opportunity to enjoy a touch of the Olympics amidst spectacular natural settings.  The campaign included films, social media activations, out-of-home advertising, experiential events, and trade promotions. Olympic-themed bottles were also available in select markets worldwide.  Offering award-winning, no-alcohol Corona Cero during the Olympic Games brought more choice to fans around the world and it was a perfect fit for this global celebration.  Corona Cero also tapped into some of the Games’ most iconic moments in real-time to drive local relevance and ensure the Games were celebrated worldwide. One example was following Gabriel Medina’s stunning mid-air celebration, when the brand leveraged its partnership with the Brazilian surfer to create a social and out-of-home campaign in key markets.  Toasting to a Future with More Cheers Cheering and celebrating sport over a beer is universal, and this partnership illustrates the opportunity for the beer category to positively engage with fans around the world while helping to create a future with more cheers."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "46  Airbnb “Paris 2024 has been Airbnb’s biggest hosting event ever with more than half a million guests welcomed during the Olympics and Paralympics. In partnership with our community of hosts, we have gone above and beyond to meet this unique occasion and contribute to make the Games a unique moment of connection and inclusivity, from investing in customer support and bolstering the offer of accessible accommodation in the Paris region to offering iconic stays and in-venue viewing experiences.” Emmanuel Marill, Regional Director for EMEA, Airbnb  Fact BOX  Exclusive category: Unique Accommodation Products, Unique Experiences Services and Olympian Experiences Services Member of the TOP Programme since: 2019"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "47  Paris 2024 was the biggest hosting event in Airbnb’s history, with more guests staying in local homes on its platform than at any event, ever before. Airbnb worked with the IOC to make the Olympic Games Paris 2024 a success for all and provide an unforgettable experience to everyone.  Experiences Hosted by Athletes  This was made possible also by a campaign launched in collaboration with Paralympic athletes Axel Allétru and Sofyane Mehiaoui and aimed at making the Games more accessible for all. Allétru and Mehiaoui became Airbnb hosts in the adapted category, inspiring more hosts to offer stays at homes with accessibility features during the Games.  To celebrate the Olympic Games Paris 2024 and in the spirit of bringing the Games to everyone, Airbnb partnered with 24 Olympic and Paralympic athletes, including basketball legend Tony Parker, to host more than 100 Airbnb Experiences. These unique Experiences allowed 1,600 guests to attend competitions alongside inspiring athletes who have made a significant impact in their sports. This initiative celebrated the spirit of athleticism and diversity during this iconic event while giving more fans access to the Games and the athletes.  Athlete Support Programmes  Unique Stays  Since their launch in 2021, both programmes have offered a combined value of more than USD 20 million in Airbnb credit to more than 30,000 athletes around the world who have booked 20,000 stays in more than 100 countries with Airbnb. As Official Partner of the Refugee Paralympic Team, Airbnb also supported the team’s athletes with training and other expenses as they prepared for the Paris 2024 Paralympic Games.  Airbnb offered a once-in-a-lifetime opportunity for two guests to spend the night in the iconic Clock Room of the Musée d'Orsay during the Opening Ceremony of the Olympic Games Paris 2024. The room was transformed into a luxurious bedroom by Mathieu Lehanneur, the designer of the Olympic and Paralympic torch for Paris 2024. In addition, Lehanneur hosted an exclusive experience on the Musée d'Orsay terrace, allowing 30 Olympic fans to witness athletes parading on the Seine while experiencing a blend of Olympic festivities, arts, design, and Parisian charm. The project generated significant press interest and social media buzz worldwide.  Accessible stays In order to ensure that people with accessibility needs could fully enjoy and participate in the Games, Airbnb made 1,000 listings with step-free accessibility features available in the Paris Region.  Airbnb also launched two multi-year programmes to support athletes. The Airbnb Athlete Travel Grant runs annually and provides USD 2,000 in Airbnb credit to selected athletes to support the cost of accommodations as they travel, train and compete. The Airbnb500 delivers USD 500 in Airbnb credit to every eligible Olympian and Paralympian competing at the Games in recognition of their incredible efforts and accomplishments.  500,000+  guests welcomed by Airbnb hosts during the Games  100  Airbnb Experiences hosted by athletes, allowing 1,600 guests to attend competitions alongside inspiring athletes  1,000+  listings with step-free accessibility features available in the Paris Region  Out-of-home campaign  Olympic Torch Relay: La Maison du Sport  To commemorate Paris 2024, Airbnb designed a unique out-of-home campaign centred around Airbnb 'Categories' that strongly resonate with the local community, while also celebrating the Games in France. The campaign aimed to actively engage with the celebration of this significant and unifying moment, showcasing Airbnb's presence within the heart of this historic event. Strategically positioned in high-traffic areas throughout Paris, including major airports, train stations, and metro stations, the ads captured the attention of a wide audience.  The Airbnb team travelled across France with the Paris 2024 Olympic Torch Relay, offering locals the chance to win tickets to Olympic events and meet renowned athletes such as basketball superstar Tony Parker or Olympic swimming champions Laure Manaudou and Camille Lacour. Local families were greeted at La Maison du Sport, a portable Airbnb home where guests participated in family-friendly games and activities. Airbnb also offered 100 hosts from the platform the unique opportunity to represent their regions as torchbearers."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "48  Alibaba “The Olympic Games has been an invaluable global platform for Alibaba to showcase our cloud and AI technology. We are proud to enable the digital transformation of the world’s largest and most complex sporting event.” Joe Tsai, Chairman of Alibaba Group  Fact BOX  Exclusive category: Cloud infrastructure, Cloud services and e-commerce platform services Member of the TOP Programme since: 2017"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:240px;left:115px;width:88px;height:14px\">\n      <a href=\"https://www.olympics.com/ioc/news/ioc-launches-new-edition-of-athlete365-business-accelerator-programme-with-support-from-alibaba-com\" target=\"_blank\"></a>\n      <div class=\"contentLink\" style=\"top:11px;left:-72px;width:98px;height:14px\">\n      <a href=\"https://www.olympics.com/ioc/news/ioc-launches-new-edition-of-athlete365-business-accelerator-programme-with-support-from-alibaba-com\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:232px;left:-15px;width:63px;height:14px\">\n      <a href=\"https://www.youtube.com/watch?v=l-oZZRfIAsY\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:-93px;left:224px;width:51px;height:14px\">\n      <a href=\"https://www.youtube.com/watch?v=4oM8bz8NGLg\" target=\"_blank\"></a>\n      <div class=\"contentLink\" style=\"top:11px;left:-105px;width:138px;height:14px\">\n      <a href=\"https://www.youtube.com/watch?v=4oM8bz8NGLg\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:92px;left:-105px;width:103px;height:14px\">\n      <a href=\"https://www.youtube.com/watch?v=Aso1wqRN5Io\" target=\"_blank\"></a>\n      </div>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n           setTimeout(function(){\n            addContentLinks();\n         },1000)   \n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  Since Alibaba Group’s TOP partnership started in 2017, its E-commerce and Cloud divisions have been driving digital transformation for the world’s largest sports events with its proven e-commerce expertise and cloud technologies; from enabling the 'biggest technological change' in the Olympic broadcasting industry for more than 50 years to creating more engaging online experience for sports fans, helping to reduce the carbon footprint of the Games and enhancing the experience for everyone involved. During Paris 2024, and in collaboration with the IOC, Alibaba.com launched a new edition of the Athlete365 Business Accelerator programme to help athletes develop their business ideas and to support their post-career entrepreneurship. Meanwhile, Alibaba Cloud contributed to the Olympic Games Paris 2024 by leveraging its AI-powered cloud technology advancements that revolutionise broadcasting, audience engagement, energy efficiency, and support for gender equality through its innovative cloud-native and AI-enabled solutions. The partnership between Alibaba Group and the IOC continues to set new standards for operational efficiency, sports fans engagement, and environmental responsibility, heralding a new era for the international sporting community. The launch of OBS Cloud 3.0, a collaborative effort between Alibaba Cloud and Olympic Broadcasting Services (OBS), marks a pivotal advancement in Olympic broadcasting. This AI-powered cloud technology served as the main infrastructure for various broadcasting functions.  49  which facilitated a deeper understanding of pivotal game moments and were made available on OBS' Content+ platform for comprehensive media analysis to all MRHs, covering a range of sports including basketball, gymnastics, tennis, beach volleyball and rugby sevens. Alibaba Cloud also helped restore and colourise Olympic archive footage from the Olympic Games Paris 1924, allowing contemporary audiences to experience these iconic moments in enhanced viewing quality and vivid colours. Furthermore, Alibaba Cloud utilised its AI-powered colourisation technology to produce 'To the Greatness of Her', an eight-minute short film highlighting the evolution of gender equality in sports. This is aligned with the Olympic AI Agenda launched in April 2024. In addition, Alibaba Cloud supported the IOC to deploy its data-driven, AI-enabled sustainability solution – Energy Expert – to help measure and analyse the electricity consumption at all competition venues during Paris 2024. By migrating the intelligence related to the power consumption and demand of the competition venues to the cloud-based platform for the first time, the solution is designed to enable more accurate analysis and better-informed power consumption planning for future Olympic Games.  Additionally, Alibaba Cloud’s showcase at the International Broadcast Centre (IBC), demonstrated the cloud pioneer’s latest cloud and AI innovations for the broadcasting and sports industry, welcoming more than 10,000 people during the Games. Visitors could interact with Alibaba Cloud Bao, a digital avatar powered by Alibaba’s large language model Qwen; play a virtual kayaking game and even send postcards and stickers produced by Alibaba Cloud’s AI image generator Tongyi Wanxiang.  On-site activations  In addition, Alibaba Cloud collaborated with the IOC to launch a Media Archiving AI Solution. This cloud-based solution provided enhanced visual search functions, automatic categorisation of multimedia content, and video highlight production through AI-powered media asset management services, marking a significant breakthrough in sports media archiving  To create a more entertaining and engaging spectator experience, Alibaba Cloud unveiled Alibaba Cloud Memento, an innovative tool that transforms participants' static images into immersive motion videos with the help of AI technology. More than 12,000 spectators experienced this transformative technology first-hand at three iconic venues: the Eiffel Tower Stadium, Champs De Mars Arena, and Invalides. The spectators could take home a video of themselves performing sports from Olympic Games, such as archery, beach volleyball, judo and wrestling created by the latest intelligent cloud-based innovation through Cloud Memento. The videos also featured historic landmarks such as the Eiffel Tower using cloud-based smart technology converting 2D snapshots into dynamic animated videos, showcasing complex sports moves with remarkable consistency and continuity.  Multi-Camera Replay Systems by OBS Cloud also provided 360-degree, framefreeze slow-motion replays. Footage was sent to the cloud, where Alibaba Cloud's AI-driven computing capabilities enabled live spatial reconstruction and real-time 3D rendering before being shared as replays,  More than 32,000 people also visited Alibaba Wonder Avenue – a dedicated Paris 2024 showcase launched by Alibaba Group at the eastern end of Champs Elysées Avenue, adjacent to the Paris 2024 Official Megastore. Designed to showcase the future online shopping  As part of OBS Cloud 3.0, OBS Live Cloud became the main method of remote distribution to Media Rights-Holders (MRHs) for the first time in the history of the Olympic Games, taking over from satellite which was launched during the Olympic Games Tokyo 1964.  in the era of artificial intelligence, Alibaba Wonder Avenue featured a smart e-commerce assistant, powered by Alibaba Cloud’s proprietary large language model Qwen, that provided a customised service for each visitor. During the journey, participants could experience the power of AI first-hand, leveraging Qwen’s multilingual and image generation capabilities.  32,000+  visitors experienced the AI-powered e-commerce experience at Alibaba Wonder Avenue  9,400  videos generated and shared by visitors to Alibaba’s Cloud Memento activation  2,000  interactions with the Alibaba Cloud Bao digital avatar at the La Rivière Alibaba Cloud Showcase"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "50  Allianz “Au revoir and merci Paris! It has been an incredible honour to be part of the Olympic and Paralympic Movements, bringing the spirit of the Games to millions worldwide. As we wrap up 29 unforgettable days of Olympic and Paralympic achievements, we celebrate the extraordinary athletes and the legacy that Paris 2024 will leave behind.” Eike Bürgel, Global Head of Olympic & Paralympic Programme at Allianz  Fact BOX  Exclusive category: Insurance Member of the TOP Programme since: 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:300px;left:96px;width:52px;height:14px\">\n      <a href=\"https://www.allianz.com/en/about-us/brand/partnerships/olympic-paralympic-movements/team-allianz.html\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:430px;left:116px;width:47px;height:14px\">\n      <a href=\"https://www.allianz.com/en/about-us/brand/partnerships/olympic-paralympic-movements/team-allianz.html#buddy-program\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:430px;left:178px;width:39px;height:14px\">\n      <a href=\"https://www.allianz.com/en/economic_research/sustainability-research/financialliteracy.html\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:440px;left:43px;width:87px;height:14px\">\n      <a href=\"https://www.allianz.com/en/economic_research/sustainability-research/financialliteracy.html\" target=\"_blank\"></a>\n      </div>\n\n\n      <div class=\"contentLink\" style=\"top:57px;left:274px;width:50px;height:14px\">\n      <a href=\"https://www.allianz.com/de/ueber-uns/brand/brand-in-action/get-ready-for-the-best.html#life\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:138px;left:235px;width:56px;height:14px\">\n      <a href=\"https://www.allianz.com/en/mediacenter/news/commitment/sponsorship/240508-allianz-the-neptune-tower-puts-on-athletic-gear-for-paris-2024.html\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:173px;left:317px;width:53px;height:14px\">\n      <a href=\"https://www.allianz.com/de/mediencenter/news/medienmitteilungen/240729-allianz-offers-unique-experiences-for-club-france-visitors.html\" target=\"_blank\"></a>\n      </div>\n      \n      <div class=\"contentLink\" style=\"top:185px;left:304px;width:71px;height:14px\">\n      <a href=\"https://www.allianz.com/de/mediencenter/news/medienmitteilungen/240729-allianz-offers-unique-experiences-for-club-france-visitors.html\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:254px;left:368px;width:17px;height:14px\">\n      <a href=\"https://www.youtube.com/playlist?list=PL35j2VgNc1zT1nmsPwDiKAK6oeGZen3b4\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:265px;left:234px;width:47px;height:14px\">\n      <a href=\"https://www.youtube.com/playlist?list=PL35j2VgNc1zT1nmsPwDiKAK6oeGZen3b4\" target=\"_blank\"></a>\n      </div>\n    \n      <div class=\"contentLink\" style=\"top:336px;left:325px;width:60px;height:14px\">\n      <a href=\"https://www.youtube.com/playlist?list=PL6CBAXPeBajk85dj17E_s_xr2fvTV1tlw\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n           setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  51  As the Worldwide Insurance Partner for the Olympic and Paralympic Games Paris 2024, Allianz provided its core expertise to support the entire sports ecosystem before, during and after the Games. This included offering commercial coverages for key venues such as the Velodrome, Aquatics Centre and Media Centre, as well as providing ticket cancellation insurance for fans. Allianz also rolled out a comprehensive medical assistance programme for 155,000 athletes, staff, volunteers and members of the Olympic and Paralympic family. Through these often ‘intangible’ solutions and services, Allianz played a crucial role in ensuring the smooth and secure operation of the Games, protecting participants and stakeholders from start to finish.  its global 'Get Ready' campaign and various market activities across more than 60 countries. These initiatives kicked off at the start of 2024 and aimed to foster a deep connection with the Olympic spirit and engage new target groups. In France, Allianz unfurled giant banners and branding in rail stations across the city to celebrate the countdown to the Games. From July through September, Club France had an exclusive area to showcase Allianz at Parc des Nations at La Villette. Here, around 10,000 visitors took part in immersive activities around the theme of sport and health protection.  A total of 49 Team Allianz athletes competed at the Olympic Games and 54 at the Paralympic Games, cheered on by more than 2,000 Allianz colleagues and supported by hundreds of Allianz volunteers who worked behind the scenes and on the ground to help ensure the Games’ success. Athletes are at the heart of Allianz’s partnership with the Olympic and Paralympic Movements, receiving not only financial backing but also career guidance through mentoring and financial literacy programmes. Whether their next step is on or off the field, Allianz is proud to support athletes as they prepare for the next chapter of their lives. Some of them have even become Allianz employees.  Fans had the opportunity to engage with the Allianz brand through explainer videos covering 55 Olympic sports and disciplines, as well as 22 Paralympic sports. Through QR codes in venues and via the official Paris 2024 website and app, Allianz enabled the audience to get ready for the best experience at the Olympic and Paralympic Games with these videos.  Allianz also brought the Movements to life for its employees, customers, distribution partners and fans through  60+  markets activated around the world  In Italy, the company produced a TV docuseries showcasing the journeys of seven Italian Team Allianz Ambassadors.  Overall, Allianz’s role at the Paris 2024 Games was multifaceted, encompassing extensive insurance coverage, robust athlete support, and global campaigns that engaged diverse audiences. Through these initiatives, Allianz contributed to the success of the Games and helped bring to life the power of sports to elevate and unite people from around the world transcending social and cultural barriers.  20m+  impressions for Olympic Sports Explainers  2bn  digital impressions for Get Ready campaign"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/QiKXdCm_9u0?si=iBe1-VtYolmy8A5L')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:550px;top:61px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "52  Atos “Our teams have demonstrated unparallelled dedication and passion to ensure the flawless delivery of the technology for the Olympic and Paralympic Games Paris 2024 in the Group’s home country. We could not imagine a better setting to showcase our expertise in digital transformation and our dedication to the Olympic Movement over the past 35 years.” Nacho Moros, CEO, Atos Major Events  Fact BOX  Exclusive category: Information technology products, services and solutions Member of the TOP Programme since: 2001"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  Atos, as the Worldwide IT Partner of the Olympic and Paralympic Games and engaged with the Olympic Movement for the past 35 years, integrated, managed and secured the critical IT systems to offer billions of fans around the world the most digital Olympic and Paralympic Games in history. Atos was the leading technology integrator, from programme management to systems integration, and the provider of over 150 core applications.  The most digital and secure Olympic and Paralympic Games in history To prepare for Paris 2024, Atos carried out more than 250,000 hours of testing from the Integration Testing Lab (ITL) in Madrid, where the Olympic Management System (OMS) and the Olympic Diffusion System (ODS) are homologated, as well as from the Technology Operation Centre (TOC) located in Paris.  250,000  hours of testing over 15 months  1,894  workstations with the on-site and remote Commentators Information System  0.35  seconds to deliver real-time results via the Olympic Diffusion System  53  The OMS was responsible for the more than 400,000 accreditations delivered during Paris 2024, as well as the competition schedule, the voting applications for athletes participating in the IOC Athletes’ Commission election, the Volunteers’ Portal and the management of operational teams. The ODS announced real-time results for the 1,026 sporting events for media and the Olympic and Paralympic families. This included the Commentator Information System (CIS), which provided from-the-field as well as background information on athletes, and the MyInfo application for remote journalists to access athlete information and news from their devices to follow the news published by the Olympic Information Service. From the TOC, Atos coordinated a team of 15 technology partners comprising more than 2,000 experts, all working to make the Olympic and Paralympic Games Paris 2024 fully connected, secure and digitally enabled. Atos also leveraged the TOC to coordinate the CTOC (Central Technology Operation Centre) located in Barcelona, with 90 Atos experts and more than 350 Venue IT Managers across all Paris 2024 operational locations. The TOC deployed a wide range of IT equipment to support the running of the competitions and delivery of results. Atos also supported the 60 Venue Results Managers, responsible for correctly gathering and publishing performance data and statistics on the ODS within a timeframe of 0.35 seconds, before it was broadcast on the competition’s websites and other media.  Atos introduced innovations like an AI-enabled Volunteer Portal, cybersecurity mesh architecture, and a Smart Knowledge Hub with GenAI for Paris 2024. Their advanced systems ensured operational efficiency, proactive threat protection, and rapid incident response, supporting the Olympic and Paralympic Games’ critical infrastructure.  Celebrating What Matters The Atos campaign for Paris 2024, 'Celebrating What Matters', highlighted the importance of athletic achievements and technological advancements, and showed Atos teams' significant role in making these moments accessible through their expertise and technology. In that spirit, Atos organised an exclusive behind-the-scenes programme for its customers, partners and media, showcasing the technological backbone of the Olympic Games and offering an immersive Olympic experience through Olympic events, and tours of the TOC and other Atos IT premises. Atos employees were also actively engaged through an internal sports and wellbeing programme, with five challenges celebrating team spirit and encouraging physical activity. Winners received rewards such as tickets, opportunities to meet Olympians, and official merchandise."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "54  Bridgestone “The Olympic and Paralympic Games Paris 2024 were an unrivalled global celebration of performance, passion, and perseverance. Their successful delivery reminded us of the power of the Olympic and Paralympic Movements to unite people across borders and help create a better world for future generations through sport. Bridgestone was proud to showcase our products and solutions in support of the athletes, organisers, volunteers and fans who made this moment so memorable.” 	 Thierry Jupsin, Vice President of Brand Marketing for Bridgestone in the Americas, Europe, Middle East and Africa  Fact BOX  Exclusive category: Tyres, certain tyre and automotive vehicle services, self-propelled bicycles, seismic isolation bearings and a variety of diversified products Member of the TOP Programme since: 2014"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  Bridgestone supported Paris 2024 operations with premium products and services to help enhance the experience for athletes, staff, fans and visitors. From advanced tyres and automotive service to bicycles and adaptive sports equipment, the company’s contributions showcased its commitments to safety, sustainability, inclusivity and innovation.  Advanced Tyres and Service for the Paris 2024 Fleet Bridgestone helped keep the official Olympic and Paralympic fleet in motion by supplying premium tyres for more than 1,000 of Toyota’s 100 per cent electrified passenger vehicles. In total, 5,374 tyres were provided to fit the vehicles in original production and support as-needed replacement on-site in Paris. This offering included the Bridgestone Turanza 6 and Bridgestone Alenza 001 tyres featuring the company’s new ENLITEN technology. More than three dozen Bridgestoneowned Speedy and First Stop service centres across the region also combined to provide tyre and glass maintenance for the Paris 2024 fleet throughout the Games. These efforts included mobile service vans that performed maintenance at Paris 2024 transportation hubs to help vehicles get back on the road quickly.  Supporting Safe and Accessible Transportation Bridgestone supported road safety education for Games-time and beyond through an e-learning module that outlined the importance of tyres and how to care for them. The training was offered to the nearly 4,000 volunteer drivers who piloted the Paris 2024 fleet during the Olympic and Paralympic Games. In addition to supporting the 100 per cent electrified passenger vehicle fleet, Bridgestone provided high-performing tyre fitments for some of Toyota’s inclusive mobility offerings. This included tyres for 250 zero tailpipe emission electric Accessible People Mover (APM) vehicles specifically designed to transport people with physical disabilities. Bridgestone also collaborated with Paris 2024 partner Decathlon to provide more than 600 bicycles for convenient use at different venues. The bikes were popular modes of non-motorised transportation for athletes within the Olympic and Paralympic Village, as well as staff and volunteers at competition sites. The majority of these bicycles are being donated to local community  55  organisations in partnership with Ville de Paris to help continue the legacy of Paris 2024.  Helping Athletes Prepare to Perform Bridgestone believes athletes are the heart and soul of the Olympic and Paralympic Games, and it proudly partnered with more than 40 Olympians, Paralympians and hopefuls to support their journeys. This roster of Bridgestone athlete ambassadors from nine different countries combined to win 20 medals at Paris 2024. Bridgestone also supported several adaptive athletes from the USA and Japan with customised rubber equipment at the Paris 2024 Paralympic Games. These innovation opportunities included the use of Bridgestone tyre rubber and technology for gloves, wheelchair hand rims, prosthetic running blades, spike plates, wheelchair tyres, and more.  Bringing the Olympic and Paralympic Spirit to Life The excitement and emotion of the Olympic and Paralympic Games Paris 2024 served as a primary connection point for Bridgestone with its employees and customers around the world. In particular, multiple global initiatives related to Paris 2024 helped create engagement and build pride with the company’s 130,000 employees. These activities led to more than 400 Bridgestone employees being able to experience Paris 2024 first-hand as runners in the Marathon Pour Tous, Paris 2024 volunteers, torchbearers, or employee recognition ticket recipients.  Dozens more had the opportunity to purchase tickets and support as spectators. The company also hosted more than 800 customers and partners in Paris during Games-time to strengthen business relationships and showcase innovation.  5,374  premium tyres provided to Paris 2024  4,000  Paris 2024 drivers offered road safety e-learning  644  bicycles supplied to Olympic Village and other venues  40  Team Bridgestone athlete ambassadors who combined to win 20 medals"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "56  Coca-Cola “Paris 2024 was an Olympic and Paralympic Games of a generation, showcasing the greatness in everyday moments. The Coca-Cola Company is proud to have played our part by supporting athletes on the global stage, while creating memorable experiences for millions of fans and spectators in Paris and around the world.” 	Brad Ross, VP Global Sports & Entertainment Marketing and Partnerships, The Coca-Cola Company  Fact BOX  Exclusive category: Non-alcoholic beverages Olympic Partner since: 1928"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/tvuCsOTQUeE?si=TQInXgeuR8eNycbw')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:535px;top:255px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n \n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  57  In its role as a Worldwide Olympic Partner, The Coca-Cola Company refreshed athletes, officials and spectators at the Olympic and Paralympic Games Paris 2024 with its wide product portfolio of beverages, including Coca-Cola, Powerade, Fuze Tea, Costa Coffee and more.  The group of established and emerging athletes from across the globe were hand-picked to carry the torch of the company’s longstanding partnership with the Olympic and Paralympic Games.  In addition, The Coca-Cola Company launched a series of activations across its portfolio of brands to engage fans and athletes alike while delivering a more inclusive experience.  Marking a historic moment in its 96-year relationship with the Olympic Movement, The Coca-Cola Company teamed up with the IOC on a new music collaboration for Paris 2024 that aimed to connect people and inspire them to unite in the celebration of music and sports.  Celebrating Everyday Greatness The Coca-Cola Company chose “Celebrate Everyday Greatness” as its theme for the Olympic and Paralympic Games Paris 2024, with a campaign designed to champion life’s everyday moments – both big and small – that can turn into something great. This theme was featured across a range of Coca-Cola brands to engage fans in the lead-up to the Games, and also inspired Coca-Cola Trademark’s global ‘It’s Magic When the World Comes Together’ campaign, which showcased the power of sport to unite people and foster cross-cultural connection.  Team Coca-Cola Continuing its long tradition of supporting athletes, The Coca-Cola Company announced a global roster of athletes representing Team Coca-Cola for Paris 2024. The team comprised dozens of competitors with diverse identities and talents, who each contributed to the “Celebrate Everyday Greatness” campaign by championing the little moments of personal excellence that helped them make their mark on the world.  'Hello World' music collaboration  'Hello World (Song of the Olympics™)' 'captured the exciting and celebratory spirit of the Olympic and Paralympic Games and was made available worldwide via all major streaming services, with an accompanying music video featuring highlights from past Games. Created by songwriter, producer, and OneRepublic frontman Ryan Tedder, the song was performed by Grammy Awardwinning global superstar Gwen Stefani and Grammy Award-winning producer, songwriter, and artist Anderson .Paak, who also collaborated with Tedder on the song’s lyrics.  Championing packaging collection & recycling Coca-Cola provided packaging options such as dispensed using reusable cups, returnable glass bottles, aluminium cans, and 100 per cent rPET bottles (excluding caps and labels) to help minimise waste, reduce carbon emissions and facilitate the recycling or reuse of the bottles to give them new life or so that they could be refilled.  1,500  Torchbearers chosen to spread real magic during the Olympic and Paralympic Torch Relays  168  placard bearers selected to precede the delegations during the Paralympic Games Opening Ceremony  6  free Coke Studio™ concerts across France, engaging 270,000 people"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/9efxZWxhpis?si=6AkmDS_xyIe2A19c')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:10px;top:555px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "58  The First Effect campaign was showcased through 35 ads across iconic Parisian locations, spotlighting Olympians and Paralympians who achieved a first  Deloitte “The Paris 2024 Games demonstrated the unifying power of sport, bringing together people from all over the world in a celebration of excellence. As the Worldwide Management Consulting Partner of the IOC, Deloitte is proud to have played a pivotal role, leveraging our deep experience to help bring the Olympics Games to the entire world.” Joe Ucuzoglu, Deloitte Global CEO  Fact BOX  Exclusive category: Management and Business Consulting Services Member of the TOP Programme since: 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('/paris2024/static/_content/pg59-vid.mp4')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:337px;top:55px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  59  9  medals won by Team Deloitte athletes  The first-ever global Team Deloitte won a total of nine medals for their respective countries  Paris 2024 was Deloitte’s first Olympic and Paralympic Games as a Worldwide Olympic and Paralympic Partner. Deloitte furthered its “partnership with purpose” with the IOC by applying its deep management and business consulting acumen to help the IOC realise the possibilities of the Olympic Movement, including enhancing and securing the IOC’s digital ecosystem, supporting its sustainability goals, and creating more engaging, effective Olympic and Paralympic Games experiences in the future.  Transforming Fan Experiences and Enhancing Technology Operations During the Olympic Games Paris 2024, Deloitte and the IOC announced an expansion of their Worldwide Olympic Partnership, with Deloitte set to take on the role of Games Technology Integration Partner for the Olympic Games, the Paralympic Games, and the Youth Olympic Games. In Paris, Deloitte created an immersive experience in its hospitality space, Maison Deloitte, to share examples of the innovations that will be delivered through this expanded category and work to date, including an augmented reality sustainability art installation, a gamified cyber security host city installation, and a commentator booth with AI-powered factoids for participants to test out. In the first two years of the partnership, Deloitte developed and established the  Olympic Fan Data platform powered by Converge™ by Deloitte for Sports, reaching more than 300 million fans during Paris 2024. Additionally, Deloitte launched the Olympic Games Learning Platform for more than 2,000 users across four Organising Committees, enabling the continuity of knowledge across the Games.  Team Deloitte Earns Nine Medals The first-ever global Team Deloitte had 10 Deloitte professionals, one Deloitte alumnus, and four sponsored athletes competing in 11 different sports at Paris 2024, winning a total of nine medals for their respective countries.  The First Effect Campaign Co-created with the IOC, The First Effect campaign redefined victory for humanity by highlighting individuals doing something incredible for the first time and quantifying the impact firsts have on the world. During Paris 2024, Deloitte celebrated 48 new firsts, including the first Olympic Games with an equal number of male and female athletes and the first medal for both the Refugee Olympic and Paralympic Team, resulting in over 225 million impressions across the campaign on social and digital channels. The campaign was showcased through 35 ads across iconic Parisian locations, spotlighting Olympians and Paralympians who achieved a first.  225m+  impressions for The First Effect campaign  1st  Games for Deloitte as a TOP Partner  Celebrating the 2024 Climate Action Awards As the presenting partner of the IOC Climate Action Awards, Deloitte hosted an event featuring influential figures from sports, business, and environmental advocacy to announce the 2024 finalists and discuss climate action through sport. These awards recognise and reward projects from National Olympic Committees, International Federations, and athletes aimed at reducing the environmental impact of sport. Following Paris 2024, four winners were awarded for their efforts to inspire the wider Olympic Movement to take climate action. Through these initiatives, Deloitte played a crucial role in enhancing the Olympic and Paralympic Games experience, supporting sustainability, and celebrating significant achievements at Paris 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n    \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/tvPGg1PyMlU?si=V4Vf-ODK0vXdAKO-')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:10px;top:65px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "60  Intel  Fact BOX  “By implementing Intel AI Platforms at Paris 2024, we enabled a more connected and enhanced experience for all and demonstrated the powerful potential of this technology to revolutionise the world of sport for athletes, organisers and fans around the world.”  Exclusive category: 5G technology platforms, VR, 3D and 360 content development platforms, artificial intelligence platforms, sports performance platforms, drones and processors   arah Vickers, Head of Intel’s Olympic and Paralympic S Games Programme  Member of the TOP Programme since: 2017"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  61  Since becoming a Worldwide Olympic Partner in 2017, Intel has brought gamechanging innovation to the onsite and broadcast experience. As the Official AI Platform Partner of the Olympic and Paralympic Games Paris 2024, Intel powered the adoption of AI technology to enhance the experience of the Olympic and Paralympic Games for fans, athletes, organisers and viewers around the world.  Automatic Highlights Generation  Intel worked with the IOC, Olympic Broadcasting Services (OBS) and other members of the ecosystem to spotlight AI’s potential to broaden access to sport through talent identification, power enhanced broadcast viewing capabilities, and enable an accessible and streamlined onsite experience. These technology applications included:  Volumetric Video  Intel AI Platform Experience To take attendees on an immersive journey of becoming an Olympic hopeful, Intel powered the AI Platform Experience at the Stade de France during the Olympic Games. Attended by more than 10,500 fans, the AI-powered fan activation used AI and computer vision to analyse athletic drills and match each participant’s profile to an Olympic sport. Trained on Intel Gaudi accelerators, running on Intel Xeon processors with built-in AI acceleration and optimised with OpenVINO, the experience demonstrated AI’s capability to identify athletic abilities and improve talent detection.  Revolutionary 8K OTT Broadcast Workflow Delivery Paris 2024 was the first edition of the Olympics to utilise Intel Xeon processors to showcase an end-to-end 8K livestreaming experience. Broadcast servers powered by the latest Intel Xeon Scalable processors with Intel Deep Learning Boost technology encoded and compressed 391 hours of total streaming at 8K/60FPS/HDR, which were distributed by OBS to eight countries worldwide.  To deliver customised content to fans, OBS Automatic Highlights Generation, trained on the Intel Geti platform, used AI to package tailored highlights across more than 30 sporting events for the first time. This effort resulted in the production of more than 100,000 personalised videos during the Games.  Two volumetric video studios set up at the International Broadcast Centre and the Olympic and Paralympic Village helped bring fans immersive 3D videos of their favourite athletes. Powered by Intel Xeon processors and optimised with Intel OpenVINO, the studios rendered more than 3,000 augmented reality clips for sharing across all platforms, demonstrating new immersive ways for fans to engage with athletes.  Universal Accessibility Wayfinding Solution Intel’s AI platform technology enabled greater accessibility at the Team USA training site in Paris and the International Paralympic Committee headquarters in Bonn, Germany. Leveraging AI built on Intel Xeon, athletes and staff could access indoor and voice navigation via a smartphone application, helping to ease wayfinding across venues.  Athlete365 Chatbot An AI-powered chatbot enabled athletes and their teams to access operational information, procedures, policies and other Olympic and Paralympic Games-time knowledge via a conversational chatbot trained on Intel Gaudi 2 AI accelerators.  10,500+  participants at the Intel AI Platform Experience  100,000+  custom videos produced via OBS Automatic Highlights Generation  With a peak of 147 queries per hour, athletes could better focus their time on training and performance rather than searching for operational details.  3,000+  volumetric video clips produced  391  hours of 8K streaming encoded and compressed at 8K/60FPS/HDR"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "62  Mengniu “Starting from humble beginnings in a house in the Inner Mongolia autonomous region 25 years ago, Mengniu Group has risen to become one of the top eight dairy companies in the world and the first Worldwide Olympic Partner from the dairy industry. The Olympic spirit inspires people to pursue excellence and challenge their limits. This striving for progress is right in line with Mengniu's ‘Born to Excel’ spirit of enterprise. In the future, Mengniu will continue to contribute to the Olympic Movement and celebrate the resilience and excellence of everyone from around the world.” Gao Fei, CEO of Mengniu Group  Fact BOX  Exclusive category: Non-alcoholic beverages and dairy Member of the TOP Programme since: 2019"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:427px;left:43px;width:165px;height:48px\">\n      <a href=\"https://www.facebook.com/chinadaily/videos/1515199192426774/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:472px;left:43px;width:86px;height:14px\">\n      <a href=\"https://www.facebook.com/chinadaily/videos/1515199192426774/\" target=\"_blank\"></a>\n      </div> \n\n\n      ",
    "script": "\n        function onPageEnter() {\n           setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n      \n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  Mengniu’s Olympic campaign for Paris 2024 embodied its core creative idea: “Nourishing the Strength of Everyone in the World.” This guiding principle extended the spirit of the Games beyond athletes to celebrate the strength and potential inherent in all individuals, inspiring people to strive for excellence in their own lives. Through innovative activations, cultural celebrations, and sustainability initiatives, Mengniu connected deeply with global audiences while reinforcing its role as both an Olympic TOP Partner and a “Sports Partner for Everyone.” In the lead-up to Paris 2024, Mengniu supported key events like the Olympic Qualifier Series in Shanghai, showcasing its commitment to athletes and fans alike. On Team China’s departure day for Paris, Mengniu collaborated with Chinese singer Han Hong to present “Blossoms All the Way,” an inspirational anthem that celebrated the journey to excellence shared by Team China and the wider community.  Fan engagement initiatives During the Games, Mengniu connected deeply with audiences through creative storytelling and innovative experiences. On the opening day of Paris 2024, Mengniu premiered an Olympic-themed short film, “The Opening,” created in collaboration with renowned director Zhang Yimou’s team. Based on the theme of “Born to Excel,” the film captured Mengniu’s journey from the grasslands of China to the global stage, intertwining the brand’s commitment to excellence with the indomitable Olympic spirit. Mengniu also engaged fans during medal-winning moments with its  63  “Mengniu Treats You to a Cup” initiative, celebrating victories by inviting consumers to share in the glory. Campaigns like “Excellence Beyond the Arena” and “Excellence Knows No Gender” reinforced the message that success belongs to everyone who strives for greatness, resonating with diverse audiences worldwide.  Celebrating culture and sustainability Mengniu hosted the first “China Night” event alongside the IOC, uniting athletes, ambassadors, and everyday heroes to share inspiring stories of perseverance. By the Seine, Mengniu transformed its “To the Milky Way” activation into an open-air running track made from recycled milk cartons. This unique installation allowed participants to actively engage in sport while celebrating Paris 2024’s “Games Wide Open” vision. Sustainability was also a key focus of Mengniu’s campaign. The company’s GREEN development strategy – highlighting governance, responsibility, carbon neutrality, and inclusive nutrition – was brought to life through its Desert Oasis activation at the Eiffel Tower Stadium. This space mirrored Mengniu’s environmental restoration work in the Ulan Buh Desert, where the company has planted 98 million trees and greened 220 square kilometres to create an organic milk source, showcasing its commitment to a greener future while offering fans a relaxing, natural retreat. Through these efforts, Mengniu seamlessly blended sustainability, culture, and sport, empowering everyone to embrace the Olympic values of excellence, inclusion, and respect.  China Night event promoted cultural exchange during the Games  Milky Way activation along the River Seine featured a running track made of recycled materials  Desert Oasis showcase offered fans a shaded relaxation space at the Eiffel Tower Stadium"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "64  OMEGA “Paris 2024 was such an energising and memorable experience for us all. The athletes were at the peak of their power, and it was OMEGA’s honour to measure each result and witness another summer of unforgettable sporting moments. We have now been part of the Olympic Games for 92 years and the inspiration and passion we feel is just as strong as ever.” Raynald Aeschlimann, President and CEO, OMEGA  Fact BOX  Exclusive category: Timepieces, timing, scoring and venue results systems and services Member of the TOP Programme since: 2003"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:393px;left:235px;width:104px;height:18px\">\n      <a href=\"https://www.youtube.com/watch?v=Th7lxTBg96c\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n           setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  For the 31st time since 1932, OMEGA fulfilled the role of Official Timekeeper at the Olympic Games, recording dreams in all 329 Olympic events across 32 sports. Continuing its legacy of precise measurement, the Swiss brand brought more than 90 years of experience to its timekeeping role and arrived in Paris with the most advanced technology it has ever delivered. A total of 550 OMEGA Timekeepers were deployed across the venues, who relied on 350 tonnes of equipment.  New Photofinish Camera One of OMEGA’s new timekeeping innovations at Paris 2024 was the Scan‘O’Vision ULTIMATE photofinish camera. Now enhanced with the highest resolution of any photofinish camera on the market, the technology captured up to 40,000 digital images per second on the finish line of races to provide each official result. The men’s 100m final in Paris was the closest in history and the ULTIMATE played a critical role in helping to decide that historic moment.  Timekeeping Highlights In total, 132 Olympic records were measured by OMEGA during Paris 2024, as well as 38 world records. Some of the most notable were the four Olympic records in swimming set by Léon Marchand of France, as well as the new world record in the men’s pole vault, reached by Mondo Duplantis of Sweden.  65  OMEGA House OMEGA House was the Swiss brand’s exclusive home for the duration of the Olympic Games Paris 2024. Located near the Musée d'Orsay, the venue welcomed members to relax during the day in a variety of sophisticated spaces and OMEGAthemed rooms, while by night, the house hosted a series of VIP events and special evenings, enjoyed alongside OMEGA’s family of celebrity friends.  The OMEGA Pavilion Located in the middle of the Parc de Bercy, the OMEGA Pavilion was an interactive venue that showcased OMEGA’s role as Official Timekeeper. Through a series of revealing installations, visitors were able to get hands-on with a variety of sports, and truly understand the timing behind each one. The main highlight was the Race of Champions experience, where visitors could test their sprinting skills on a 10m running track and digitally compete against real Olympic or Paralympic athletes.  OMEGA Marketing The visuals for OMEGA’s Paris 2024 marketing transformed Paris into a dreamlike playground, where the most recognisable city sights became a stage for sporting glory. The brand’s TVC played with scale and optical illusion to seamlessly blend OMEGA’s sporting ambassadors with iconic Parisian surroundings, and included original music performed by rapper SDM.  550  OMEGA timekeepers positioned on-site  38  new world records measured  3  unique OMEGA watches created for Paris 2024  OMEGA Paris 2024 Watches Three new OMEGA watches were created in honour of the Olympic and Paralympic Games Paris 2024. • The Speedmaster Chronoscope emphasises the brand’s spirit of precision timing and features tachymeter, telemeter, and pulsometer scales on the dial. • The sporty and bold Seamaster Diver 300M includes a bezel made from 18K gold, making the link between time and victory. • The vintage-style Paris 2024 Bronze Gold Edition incorporates the iconic materials of gold, silver and bronze, as an emotive reminder of the medals that every athlete strives for."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "66  Panasonic “The Paris 2024 Games represented a once-in-a-lifetime opportunity for us, as a Worldwide Partner, to collaborate closely with the IOC, IPC and the Paris 2024 Organising Committee to deliver memorable Games. We poured our hearts into providing our latest AV solutions, broadcast equipment, and sound systems to ensure that the event would be a resounding success and a truly unforgettable experience for everyone involved.” 	Tak Kosugi, Head of Worldwide Olympic & Paralympic Marketing at Panasonic  Fact BOX  Exclusive category: Audio/TV/video equipment, home appliances Member of the TOP Programme since: 1987"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  67  In line with the Organising Committee's mission to make Paris 2024 the most sustainable Games, Panasonic committed to providing the following state-of-the-art AV solutions: • Panasonic's KAIROS' IT/IP platform helped deliver video content to public video boards at nearly every competition venue. This groundbreaking solution transformed workflows and streamlined operations, allowing Olympic Broadcasting Services (OBS) to produce compelling content for up to three venues from a single KAIROS Core, creating memorable moments for all. • 58 PTZ cameras were installed in 29 press rooms to consolidate and provide simultaneous translation at the Main Press Centre (MPC). This effort drastically helped reduce the need for equipment and travel to each competition venue during the Games, making it easier for voices from around the world to be heard and celebrated. • In the largest deployment of projectors ever seen at a single edition of the Olympic and Paralympic Games, Panasonic proudly installed 160 laser projectors to light up competition venues and dazzle audiences with projection mapping at La Defense Arena, the Vélodrome, and during the Opening Ceremony of the Paralympic Games. Panasonic’s labour-saving projection technology not only minimised the use of resources for transportation, storage, and installation but also significantly reduced the event's carbon footprint.  Taking Urban Sports and Breaking to the Next Level with Technics As part of the Panasonic portfolio, Technics DJ turntables and headphones were supplied to iconic venues such as the breaking competition, where a unique blend of sound and vibes  As founding partner of the programme, Panasonic proudly collaborated with many IOC Young Leaders who came from all around the world to promote their projects and passions with the local audiences.  immersed the audience in the world of breaking and urban sports. In addition, to celebrate Technics' powerful influence on hip-hop culture, Panasonic organised an unforgettable event at La Concorde, inviting visitors to experience the world of hip-hop with DJ turntable tutorials, break-dancing classes, and graffiti spray-painting trial walls, creating the perfect bridge between hip-hop culture, urban sports, and the Olympic Movement.  280,000  visitors to the Champions Park, where Panasonic shared their passion for the Olympic Movement  Heartfelt celebrations and memorable moments at Champions Park As the official Presenting Partner at the Champions Park, the iconic venue where Olympians were celebrated throughout the Games, Panasonic hosted a pre-show using its AV equipment and Technics DJ turntables to ensure everyone was ready to share their passion. The Dance Cam pre-show was a symbolic and impactful on-site activation that united attendees in celebrating the Games. Panasonic’s on-site activation featured memorable surprises, including appearances by Olympic legends and Team Panasonic ambassadors Nathan Chen and Michael Phelps, leaving a lasting impression on all present. Additionally, located near Champions Park in the Trocadero Gardens, the IOC Young Leaders booth promoted the initiatives of the joint IOC and Panasonic programme that aims to create a brighter future through sport.  160  projectors, marking the highest number ever utilised in a single edition of the Games  26  venues featured Panasonic's revolutionary KAIROS' IT/IP platform to simplify workflows and streamline operations"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "68  P&G “After 14 years of partnership, we continue to be moved by the superior performance of Olympic and Paralympic athletes. I had the honour of visiting Paris to see our brands in action – serving athletes in the Olympic and Paralympic Village Paris 2024. Our brands have been doing this for a long time, and still, it is so special to see how they show up to support athletes by providing the comforts of home so they can focus on performing at their best when it matters most.” 	Marc Pritchard, Chief Brand Officer, P&G  Fact BOX  Exclusive category: Personal care, healthcare and household care products Member of the TOP Programme since: 2010"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:178px;left:232px;width:101px;height:14px\">\n      <a href=\"https://www.olympics.com/en/athletes-for-good/\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n           setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  P&G brands supported the athletes of Paris 2024 by providing more complimentary products and services in the Olympic and Paralympic Village than ever before to help to meet their everyday needs. For the first time, Pampers sponsored a Village Nursery, a comfortable and convenient place for athlete parents to make precious memories with their little ones during the Games. A place for feeding, bonding and playtime, the Nursery also provided the highest quality Pampers diapers and wipes for the more than 60 families who booked to experience the space. In the Beauty & Grooming Salon, brands like Head & Shoulders, Pantene, Mielle, Gillette and Braun provided complimentary haircuts, styling, and facial grooming so athletes could look and feel their best as they stepped onto the world’s biggest sporting stage. In all, the brands delivered more than 2,900 beauty and grooming services to athletes from 147 countries. In addition, Ariel sponsored the laundry rooms, delivering 60,000 loads of coldwater cleaning for athletes’ clothes and uniforms. Oral-B sponsored the dental clinic to give athletes the confidence of healthy smiles. Always and Tampax provided period protection products throughout the restrooms in the Village. And each athlete received a P&G Everyday Champions welcome kit with P&G brand products to support their health and hygiene needs.  Everyday Champion Brands Inspired by the highest performance of the best athletes in the world, more than 30 of P&G’s household and personal care brands launched Olympic and Paralympic Games-inspired marketing campaigns, featuring the highest performance products that serve people every day.  69  These campaigns came to life in-store and online across more than 250 retailers in over 40 countries. P&G brands also united behind the theme of “Everyday Champions,” providing products that give their best every day to meet the household and personal care needs of athletes, families, and fans – just like Olympians and Paralympians give their best to their sport.  Athletes for Good P&G and its brands continued the Athletes for Good (AFG) programme for Paris 2024, in partnership with the IOC and IPC, awarding 20 grants of USD 24,000 each to charities athletes nominated, to fuel the positive work they are doing together. Just as P&G brands aim to deliver superior performance every day and make a positive impact in the community, so, too, do the athletes recognised with AFG grants. P&G is delighted to help these athletes continue to make a meaningful impact beyond the sporting field of play.  Paris 2024 Podiums Together with the IOC, IPC, and Paris 2024 Organising Committee, P&G helped create the ultimate symbol of performance – the Olympic and Paralympic Games Paris 2024 podiums. The podium represents the pinnacle of an athlete's journey, after years of perseverance in the daily pursuit of sporting excellence. P&G brands share this same commitment to creating top-performing products that consumers can count on every day. Created in the host country of France – from the materials and design inspired by the iconic work of Gustave Eiffel to the manufacturing and assembly – the podium symbolised excellence, creativity, and know-how. P&G was honoured to play a role in creating a platform that athletes are proud to stand on after the achievement of a lifetime.  2,900  beauty and grooming services delivered to athletes in the Olympic Village  60+  athlete parents booked in to experience the Olympic Village Nursery  30  P&G brands launched Games-inspired marketing campaigns"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "70  Samsung  Fact BOX  “Samsung continues to unite fans around the world with innovative technology as a proud partner of the Olympic Movement for over three decades, and Paris 2024 was another incredible experience for us all. Together with the IOC, we delivered seamless operations throughout all aspects of the Olympic Games, creating invaluable moments of connection and inspiration for all Olympic families and athletes” 	YH Lee, President of the Global Marketing Office, Samsung Electronics  As the official Wireless Communications and Computing Equipment partner of the Olympic and Paralympic Games, Samsung played a crucial role in supporting Paris 2024. The company utilised its cutting-edge mobile technologies to transform the ways in which the Olympic  and Paralympic communities, athletes, and fans communicated and shared their experiences. This revolution in connectivity and interaction made the Games and its operation more accessible and engaging for all participants, significantly enhancing the overall experience.  Exclusive category: Wireless communications equipment and computing equipment Member of the TOP Programme since: 1997  ‘Open always wins’ Samsung’s central message for the Olympic and Paralympic Games Paris 2024, ‘Open always wins,’ aimed to reflect the brand's belief that an open mind turns every new experience into a meaningful achievement, opening up new perspectives and endless possibilities. This message was at the heart of all Samsung’s activations throughout the Games and was brought to life through the stories of Team Samsung Galaxy athletes, who demonstrated how being open enables you to do extraordinary things."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  Galaxy Z Flip6 Olympic Edition All eligible athletes competing at Paris 2024 were gifted their own custom-built Olympic Edition of Samsung’s Galaxy Z Flip6 smartphone, specifically designed to enhance their Games-time experience. As well as being the first-ever Olympic Edition smartphone to feature Galaxy AI, the devices also came pre-loaded with a full suite of exclusive services and useful apps, including an eSIM of 100GB 5G data, an unlimited complimentary public transport access card and several official Olympic apps, designed to help the athletes open up new experiences and connect with new people while they are in Paris. These included the new Athlete365 app, the official Paris 2024 transport app, the Olympic Shop and Olympics™ Go! Paris 2024 – the official mobile game for Paris 2024.  71  Supporting Team Samsung Galaxy athletes Samsung has been supporting athletes for almost 40 years. For Paris 2024, Samsung partnered with a roster of inspiring global athletes – including British skateboarder Sky Brown, French surfer Johanne Defay, para swimmer Ugo Didier, Dutch marathoner Sifan Hassan, American skater Jagger Eaton and surfer John John Florence, Australian wheelchair racer Madison de Rozario, Brazilian skateboarder Rayssa Leal, South Korean badminton star Se-young An and football icon Heung-min Son. Team Samsung Galaxy athletes served as the primary voices for ‘Open always wins’ and, by sharing their journeys, demonstrated how Samsung is helping athletes and fans open up to new opportunities through its technologies.  Enabling the first-ever Victory Selfies  Enhancing the Games-time experience for fans  For the first time in Olympic and Paralympic Games history, Samsung also provided its Galaxy Z Flip6 Olympic Edition smartphones for use on the podium at Paris 2024, enabling medallists at the Games to commemorate their crowning moment with a unique “Victory Selfie ”.  Fans and athletes in Paris for the Olympic and Paralympic Games were able to try out the Galaxy Z Flip6 Olympic Edition smartphone and other Galaxy innovations at three pop-up Samsung showcasing experiences across Paris (located at Champs-Elysees 125, Square Marigny and the Village Plaza in the Olympic & Paralympic Village). More than 380,000 visitors to these showcases experienced the latest Galaxy innovations first-hand, discovering new ways to create and communicate with Galaxy AI. They also took part in a historic tradition, as more than 350,000 Samsung Olympic Games pins were distributed to and traded by fans of all ages  A total of 253 selfies were captured throughout the Games, with Samsung’s customised technology then mapping and sorting the images by sport before uploading them to the IOC’s Athlete365 platform, which allowed athletes to save and share their podium experience with family and fans on social media.  Providing tech for a new view of all the action In collaboration with the IOC and Olympic Broadcasting Service (OBS), more than 200 Galaxy S24 Ultra smartphones were installed on the boats used in the Olympic Games Opening Ceremony on the River Seine and the sailing competition in Marseille. Footage was transmitted by Orange through a newly installed, private 5G network and brought fans closer to the excitement.  Powering Games-time operations From managing ticketing systems and stadium entry to facilitating event broadcasts, nearly 15,000 Galaxy devices were used by Paris 2024 staff and volunteers to deliver efficient and seamless operations throughout the Games. This included more than 7,100 Galaxy smartphones, over 2,500 Galaxy Tab series tablets and 5,200 Galaxy Book series laptops.  Launching ‘Together for Tomorrow, Enabling People’ community During the Olympic Games, Samsung and the IOC announced the launch of a new digital community that aims to engage young people around the world with the Olympic Movement and leverage the transformative power of technology and sport to make a meaningful difference in the world. “Together for Tomorrow, Enabling People”, which was unveiled at an event in Paris on 31 July, is a joint initiative between Samsung and the IOC aimed at engaging younger generations and creating a positive impact in the world through sport and technology. The new digital community is designed around the goal of helping young people experience three core values – social  17,000 Samsung Galaxy Z Flip6 Olympic Edition smartphones provided to competing athletes  253  Victory Selfies taken with Samsung Galaxy Z Flip6 Olympic Edition  15,000  Galaxy devices including phones, tablets and note PCs utilised by Paris 2024 organisers  380,000+  fans engaged at the Olympic™ rendezvous @ Samsung pop-up experiences across Paris  3 million  fans from 140 countries participated in the ‘Together for Tomorrow, Enabling People’ community activity; Solve, Move, and Create challenges  350,000+  Samsung Olympic Games Pins distributed to fans and athletes  contribution, health and creativity – and enables them to participate in a series of collaborative Olympic challenges designed to create a better tomorrow. The initiative builds on Samsung’s existing Together for Tomorrow initiatives, which aim to empower and support the next generation to achieve their full potential and pioneer positive social changes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "72  Toyota “Sports have the power to unite. It has been incredible and inspirational to watch the athletes, their families and communities on the road to their Olympic and Paralympic success. Their relentless pursuit of excellence inspires us all to start our own 'impossible'.” 	Yoshihiro Nakata, President and CEO of Toyota Motor Europe  Fact BOX  Exclusive category: Vehicles, mobility support robots and mobility services Member of the TOP Programme since: 2017"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  For the Olympic and Paralympic Games Paris 2024, Toyota delivered a 100 per cent electrified passenger vehicle fleet and an array of inclusive solutions, making sure that the athletes, officials and volunteers could easily move around the Games in a safe and sustainable manner.  Accessible People Mover The Accessible People Mover (APM) is Toyota's electric mobility vehicle designed specifically for Paris 2024 to transport people, goods, and act as a stretcher in emergencies. The APM features integrated wheelchair ramps, comfortable seats, and a top speed of 20 km/h. Its low floor and wide doors ensure easy and safe boarding. Additionally, the APM is eco-friendly, running on battery power and producing zero tailpipe emissions. Designed by Toyota Motor Europe in Belgium and manufactured in Toyota Caetano Portugal, the 250 APM covered 140,000 kilometres during Paris 2024, enhancing the mobility experience for athletes, staff, volunteers, and visitors.  Last-mile mobility solutions Toyota co-developed Yosh-e – the wheelchair e-puller – to bring their vision of “Mobility for all” to life at the Paralympic Games Paris 2024. The Yosh-e converts a classic mechanical wheelchair into a battery-powered electric mobility solution, giving more freedom of movement to wheelchair users. During the Paralympic Games, the Toyota team installed over 240 brackets on athletes’ wheelchairs so that they could make use of the 50 Yosh-e e-pullers, made available through the KINTO app. In addition to the Yosh-e wheelchair puller, Toyota also provided electric last-mile  73  mobility solutions such as C+WalkS and C+WalkT to the volunteers and the athletes of Paris 2024, allowing the latter to save their energy for their performances.  100 per cent electrified vehicle fleet In line with Toyota’s multi-path strategy and commitment to support Paris 2024’s environmental ambitions, the company delivered a 100 per cent electrified passenger vehicle fleet. In fact, approximately 60 per cent of the fleet were zero-tailpipe emissions, including battery electric vehicles (BEV) like the Toyota bZ4X, Proace, Proace Verso and Lexus RZ, as well as fuel-cell electric vehicles (FCEV) like the Toyota Mirai. Additionally, Toyota brought around 1,000 hybrid (HEV) and plug-in hybrid (PHEV) vehicles, including the globally best-selling RAV4 in both PHEV and HEV versions, along with the Toyota Corolla TS, Yaris Cross and Highlander, all featuring hybrid technology. Around 60 per cent of the Toyota fleet was produced in Europe, including 37 per cent in France, contributing to the vision of a sustainable and locally sourced Paris 2024.  100%  electrified passenger fleet  2,700+  electrified vehicles  Hydrogen society Toyota demonstrated its vision of a hydrogen society through more than ten applications, ranging from passenger cars to heavy-duty transport, highlighting the potential of hydrogen technology in achieving carbon neutrality. The diverse fleet included 500 Mirai, 14 Caetano fuel cell buses, 10 fuel cell coaches, two fuel cell Hilux, and others – in total over 10 different applications. Hydrogen-powered, zero tailpipe emission vehicles at Paris 2024 achieved an impressive milestone,  850+  inclusive mobility solutions  covering over one million kilometres – equivalent to 25 trips around the globe, and using nearly 12 tons of hydrogen sourced from renewable origins."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "74  Visa “The spirit of Paris 2024 was aligned with Visa’s mission to uplift everyone, everywhere. We believe the Games are a powerful platform to drive inclusion and economic growth. We’re delighted to play our part in enabling the success of Paris 2024 for both the Olympic and Paralympic Games by providing the most convenient and secure way for spectators and travelers to pay. We proudly supported Team Visa athletes, showcasing their incredible talent, grit and dedication.” 	 Andrea Fairchild, Senior Vice President of Global Sponsorship Strategy, Visa  Fact BOX  Exclusive category: Payment services, transaction security, credit, debit, prepaid cards, digital wallets Member of the TOP Programme since: 1986"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:265px;left:232px;width:115px;height:34px\">\n      <a href=\"https://usa.visa.com/about-visa/newsroom/press-releases.releaseId.20776.html\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n           setTimeout(function(){\n            addContentLinks();\n         },1000)\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  As a founding member of the TOP Programme in 1986 and the first global partner of the International Paralympic Committee (IPC) in 2003, Visa’s long-time relationship with the Olympic and Paralympic Games has always been about empowering athletes to be successful both on and off the field while providing convenient, reliable, and secure payment solutions. Team Visa for Paris 2024 featured 147 athletes representing 67 countries across 40 sports, making this Visa’s largest and most diverse roster yet - featuring 67 men and 80 women, and increasing the representation of Paralympic athletes at Paris 2024. This year's roster of athletes won 100 medals - 55 Olympic and 45 Paralympic medals. As the exclusive Payment Technology Partner, Visa collaborated with the Organising Committee to build a custom payment network, ensuring contactless payments were accepted at 3,500 points of sale in Olympic and Paralympic venues.  Blending sports with culture and commerce To give thanks to Parisians for opening their city and country to the world and providing a vibrant and welcoming atmosphere for all, Visa celebrated the intersection of sport, art, and culture by commissioning six global artists to create works of art to appear on billboards throughout Paris (a global capital for street art). The street art installations highlighted Visa Go, a mobile app designed to help users experience the best of the city. The app enabled access  75  to Team Visa content, and a curated selection of discounts and offers from official partners, local shops, and restaurants. Visa’s aim was to celebrate the Olympic and Paralympic Games and help promote local small businesses and culture through art. The street art included works from leading street artist Marko 93 (France) from Seine-Saint-Denis; influential street artist and activist Swoon (USA); pioneering graffiti artist JonOne (USA); native Parisian artist Olivia De Bona (France); prolific colourblind street artist Alex Senna (Brazil); and multidisciplinary artist Vexta (Australia) and received significant media interest.  147  Team Visa for Paris 2024 featured 147 athletes  Helping to boost the French economy Additionally, the French economy benefited from hosting the Olympic and Paralympic Games, and Visa played a part in this success, according to proprietary data which revealed Visa cardholder spending patterns during the Olympic Games. Not only did Paris attract 42 per cent more Visa cardholders in the first week of the Olympic Games than in the same period in 2023, but other cities hosting Olympic Games events also saw significant increases in visitors and spending, especially among fans who attended the competitions. The most significant year-on-year increase in spending levels in Paris was seen in restaurants: a 49 per cent increase. During the first weekend of the Olympic Games, small businesses in Paris benefitted from a 26 per cent year-on-year rise in sales from Visa cardholders.  100  Team Visa athletes at the Olympic and Paralympic Games won a total of 100 medals  3,500  Contactless payments were accepted at 3,500 points of sale in Paris 2024 venues"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "76  Domestic Partnerships “Celebration, engagement and legacy: these three words sum up the partners' contribution. Without our partners, these Games would not have been such a success.” 	 Ludivine Roosebeke, Paris 2024 Partnerships Director  Accor As a Premium Partner of the Olympic Games Paris 2024, Accor played a central role in showcasing France’s world-renowned hospitality and culture on the global stage. As the birthplace of the company, France offered Accor the opportunity to demonstrate its heritage and expertise in delivering exceptional service. The Games became a “sparkling advert” for French tourism, with Accor highlighting the nation’s rich traditions in cuisine, art and culture. Accor was the first hotel group to oversee operations of both the Athletes’ and Media Villages, managing over 90 buildings and 16,000 beds. This immense logistical undertaking was seamlessly executed,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  77  The partnership also highlighted BPCE’s support for the French sports ecosystem. The group sponsored France’s largest cohort of elite athletes and played an active role in mobilising communities through initiatives like the Olympic Torch Relay. With more than 100,000 employees, Groupe BPCE embraced the spirit of the Games, sharing in the emotions and triumphs of athletes and fans, making Paris 2024 a truly memorable experience for all.  Carrefour Carrefour, one of the world’s leading food retailers, brought its vision of “the food transition for all” to life during Paris 2024. As a Premium Partner, Carrefour demonstrated its commitment to providing high-quality, accessible and affordable food, ensuring that athletes, spectators and participants could experience the Games in a meaningful way. Through its “Nourishing Every Hope” campaign, Carrefour celebrated the aspirations of athletes striving for victory, the joy of fans experiencing the thrills of competition, and the pride of its employees contributing to a historic event. Carrefour’s partnership underscored its role as a vital player in supporting communities and the Olympic Movement.  demonstrating Accor’s ability to deliver tailored solutions for complex global events. Beyond logistics, Accor delighted fans and guests with unique moments at venues such as Le Club France, ensuring a welcoming and memorable experience.  Groupe BPCE With a long-standing commitment to sport, Groupe BPCE became the first Premium Partner of Paris 2024 in 2018, marking the beginning of six years of collaboration that culminated in its vital contributions to the Games’ success. Groupe BPCE financed major infrastructure projects, including the Olympic Village, and developed the largest ticketing system in Olympic history, making the Games accessible to fans across France and beyond."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "78  EDF A key force in the energy transition, EDF supported Paris 2024 as both a Premium Partner and the Official Supplier of Renewable Energy. EDF’s contributions embodied the Games’ commitment to sustainability and inclusion, making a lasting impact on athletes, fans, and communities. EDF spearheaded initiatives such as the “1,2,3 Swim!” programme, which taught swimming skills to 100,000 children from underserved neighbourhoods. This effort complemented EDF’s wider support for sport, which includes fostering inclusion through its “Un Champion dans mon École” programme to raise awareness of disability issues among youth. The EDF Pavilion, located near the Champs-Élysées, served as a hub for visitors, offering an engaging and festive space to celebrate the Games. EDF’s commitment to Paris 2024 demonstrated its role as a driving force behind the Games’ success and a champion of sustainability and accessibility.  LVMH LVMH brought the essence of French creativity and craftsmanship to the Olympic Games Paris 2024. Through its creative partnership, the company celebrated its mission, “The Art of Crafting Dreams,” and the Olympic values of excellence and inclusivity. Iconic LVMH Maisons contributed their expertise during key moments of the Games. Berluti designed the opening ceremony outfits for the French delegation, while Chaumet crafted the medals, and Louis Vuitton created bespoke trunks for both the Olympic torch and medals. Dior and Moët Hennessy enhanced the Games’ artistic and hospitality experiences, while Sephora played a significant role in the Torch Relays. LVMH also embraced sustainability, designing upcycled outfits for victory ceremonies and engaging with fans through its presence at Champions Park and Club France, ensuring a memorable and inclusive celebration of excellence and culture.  Orange As a Premium Partner and Official Supplier to Paris 2024, Orange played a pivotal role in making Paris 2024 the most connected Games in history. The company was tasked with"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Olympic Partnerships  79  connecting 120 venues, 15,000 athletes, and over 878 sporting events, ensuring billions of fans worldwide could experience the Games in real-time. Orange also supported inclusivity and community engagement through initiatives like the Marathon Pour Tous, the first-ever Olympic event open to the general public. Over 40,000 runners participated, embodying the Games’ spirit of openness and unity. By seamlessly delivering cutting-edge technology and engaging fans on a personal level, Orange helped Paris 2024 reach new heights in connectivity and accessibility.  Sanofi Sanofi celebrated human achievement in sport and science through its partnership with Paris 2024. As a Premium Partner of Paris 2024 and Official Partner of the Olympic and Paralympic Torch Relays, Sanofi demonstrated its commitment to excellence, innovation, and inclusivity. Sanofi’s employees contributed significantly to the Games’ success, with over 2,000 volunteers – the largest cohort at Paris 2024 – and nearly 300 Torchbearers participating in the relays.  Additionally, Sanofi made a lasting impression during the Opening Ceremony with the introduction of Zeus, a symbolic metal horse that captured the spirit of perseverance and determination.  Through these efforts, Sanofi reinforced its dedication to making a positive impact on people’s lives while celebrating the Olympic values of excellence, friendship, and respect."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Digital Engagement"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n      \n      \n       <h1 id=\"82-no\" class=\"abs olympic-HeadlineReg 82-no\" style=\"top:645px;left:464px; font-size: 1.5em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 412, \"append\": \"BN\" }' ></h1>\n       <h1 id=\"82-no\" class=\"abs olympic-HeadlineReg 82-no\" style=\"top:715px;left:466px; font-size: 1.5em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 270, \"append\": \"M\" }' ></h1>\n       <h1 id=\"82-no\" class=\"abs olympic-HeadlineReg 82-no\" style=\"top:780px;left:466px; font-size: 1.5em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 290, \"append\": \"%\" }' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        pg82Anim = new TimelineMax();\n        pg82Anim.fromTo(cOf(\"82-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0])}}, 1.0)\n        pg82Anim.fromTo(cOf(\"82-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1])}}, 1.1)\n        pg82Anim.fromTo(cOf(\"82-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[2])}}, 1.2)\n        }\n\n        function onPageLeave() {\n        pg82Anim.stop();\n        resetNumbers(\"82-no\");\n        }\n      ",
    "searchText": "82  Digital Engagement THE OLYMPIC GAMES PARIS 2024 GENERATED RECORD-BREAKING DIGITAL ENGAGEMENT, WITH THE IOC PREPARING A MULTI-FACETED, MULTIPLATFORM APPROACH TO REACH MORE PEOPLE THAN EVER BEFORE IN NEW AND INNOVATIVE WAYS  The Olympic Games Paris 2024 set a new benchmark for digital engagement, delivering record-breaking results across platforms and connecting millions of people to the Games in innovative and meaningful ways. Anchored by a multi-faceted, multiplatform approach, the IOC’s digital initiatives reached hundreds of millions of people through immersive storytelling, interactive fan experiences, and dynamic global collaborations. From the launch of the new “Sport. And More Than Sport” brand platform to cutting-edge digital  experiences, Paris 2024 redefined how fans engage with the Olympic Games. Across social media platforms, there were an estimated 412 billion engagements from 270 million posts, representing a 290 per cent increase compared to the previous edition of the Games. These results were the culmination of the IOC's efforts in recent years to grow digital engagement with people during and between the Olympic Games, with this strategic vision driven by Olympic Agenda 2020 and Olympic Agenda 2020+5.  “Sport. And More Than Sport” “Our digital records have been broken across Olympic digital, social media and marketing platforms.” 	 Leandro Larrosa, IOC Digital Engagement & Marketing Director  The “Sport. And More Than Sport” brand platform launched ahead of Paris 2024 and was the unifying theme for digital experiences and content during the Games, celebrating sport’s ability to inspire, empower, and connect with people both on and beyond the field of play.  Paris 2024 on social media  412bn  engagements  270m posts  290%  increase in engagements compared with Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "\n      \n           \n       <h1 id=\"83-no\" class=\"abs olympic-HeadlineReg 83-no\" style=\"top:145px;left:252px; font-size: 2.1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 325, \"append\": \"M\" }' ></h1>\n       <img class=\"abs halfScaleC 83-text\" style=\"top:215px;left:358px;\" src=\"/paris2024/static/_content/83-no.png\"/>\n       <h1 id=\"83-no\" class=\"abs olympic-HeadlineReg 83-no\" style=\"top:335px;left:466px; font-size: 2.2em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 16.7, \"decimals\": 1, \"append\": \"BN\" }' ></h1>\n       <h1 id=\"83-no\" class=\"abs olympic-HeadlineReg 83-no\" style=\"top:458px;left:491px; font-size: 2.2em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 32, \"append\": \"M\" }' ></h1>\n   \n      \n      ",
    "script": "\n        function onPageEnter() {\n        pg83Anim = new TimelineMax();\n        pg83Anim.fromTo(cOf(\"83-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"83-no\")[0])}}, 1.0)\n        .fromTo(cOf(\"83-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"83-no\")[1])}}, 1.3)\n        .fromTo(cOf(\"83-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"83-no\")[2])}}, 1.4)\n        .fromTo(cOf(\"83-text\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n\n        }\n\n        function onPageLeave() {\n        pg83Anim.stop();\n        resetNumbers(\"83-no\");\n        }\n    \n      ",
    "searchText": "IOC Marketing Report Paris 2024  Digital Engagement  83  Record-breaking digital engagement  325m  Olympics.com & Olympics App users  No.1  sports app in over 70 territories  16.7BN engagements on Olympic-owned social handles  32m  more followers of Olympic-owned social handles (151m total)  “Engagement on social media platforms went through the roof, with a 290 per cent increase on the previous edition of the Games. Audiences are following and interacting with the Olympic Games like never before.” 	 Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "\n      \n\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/oIzH8L-WeMM?si=zOMPFM-Z_WG6kAla')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:12px;top:795px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n      \n      ",
    "searchText": "84  It launched with an uplifting short film that encapsulated the “Olympic Spirit”, airing globally across the network of Olympic Media Rights-Holders (MRHs) and Olympic digital channels. In France, the film reached an even broader audience through cinemas, helping to build excitement for the Games. During the Games, “Sport. And More Than Sport” resonated through creator collaborations and interactive fan experiences, such as an interactive art installation, where people in the streets of Paris were invited to reflect on their personal victories over life’s challenges. This also came to life across Olympic social media handles, reacting to the most memorable “More than Sport” moments of the Games, such as Leon Marchand’s medal-winning performances in the pool, which united local fans, and Rebecca Andrade’s sportsmanship, which inspired audiences worldwide. On Olympics.com, the campaign was reflected in powerful athlete stories and human-interest features, generating millions of engagements per post during the Games.  Olympics.com Olympics.com served as the ultimate destination for Olympic fans during Paris 2024, providing a comprehensive source for breaking sports news, video highlights, and original content to more than 325 million unique users during the Olympic Games. Designed to bring fans closer to the action, the platform offered a wide array of features and bespoke coverage in 11 languages, ensuring accessibility for a global audience. The platform produced and published more than 148,000 content assets resulting in three million hours of video watch-time.  498.5m social media engagements on the Sport. AND More than Sport. brand platform  Throughout the Games, Olympics.com published nearly 6,000 stories, with content ranging from event previews and daily highlights to unique behind-thescenes coverage on the surfing events in Tahiti and the vibrant scenes across Paris. Fans could also enjoy in-depth athlete interviews – over 100 in total – and original podcasts featuring legendary sporting figures. The platform's live blogs, available in French, English, Spanish, Italian, Portuguese, German, Japanese, and Mandarin, offered real-time updates and insights, attracting millions of readers, including 5.4 million fans on the English-language blog alone."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 84,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg85.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Digital Engagement  85  Celebrating and empowering athletes digitally Throughout the Olympic Games Paris 2024, athletes were celebrated digitally, with innovative features recognising their achievements. Through the IOC’s collaboration with Meta platforms, thousands of Olympians received free verification for their accounts, enhancing their online presence and connection with fans. On X (formerly Twitter), Paris 2024 medallists were honoured with custom badges marking their Olympic triumphs, while fans could also join the celebration by using a custom bouquet feature on Google, allowing them to send virtual congratulations to their favourite medal-winning athletes. The IOC also introduced several innovative initiatives during Paris 2024 to empower athletes to connect with fans in new and meaningful ways. Athletes were given unprecedented opportunities to share their Olympic  Interactive features further enriched the fan experience. Visitors could customise medal tables and event schedules, tailoring the platform to their favourite teams, athletes, and sports. The newly introduced Play Hub offered fans opportunities to participate in live meet-and-greets with stars such as skateboard park gold medallist Arisa Trew and Olympic legends Nadia Comaneci and Aly Raisman. Fans could also engage with the Games by voting for their favourite moments, entering contests to win Paris 2024 prizes, and even being featured on the fan-powered social wall, making Olympics.com a vibrant hub for active participation and connection.  journeys on their personal social media accounts, while the IOC also collaborated with celebrities, influencers, and athletes from various fields to promote the Games to younger, non-sport audiences. These partnerships were highly effective in driving traffic to the MRHs’ platforms via targeted links, significantly broadening the Games’ reach. Additionally, the #RoadToParis2024 pilot project, a collaboration between the IOC and the World Federation of the Sporting Goods Industry (WFSGI), allowed eligible WFSGI member sports brands to celebrate their sponsored athletes’ journeys to, during, and after the Games. The initiative generated over three billion social media engagements, amplifying the impact of Paris 2024 and highlighting the athletes’ incredible stories."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 85,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg86.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "86  Collaborating with TOP Partners  THANKS TO OUR WORLDWIDE OLYMPIC PARTNERS  A  s the IOC continues to expand its digital footprint and engagement, a key aspect of its strategy involves close collaboration with the Worldwide Olympic (TOP) Partners. These efforts create meaningful opportunities to build awareness of the Olympic partnerships while connecting partners' brands with Olympic audiences across the IOC’s owned digital platforms and channels, and beyond. Together with its partners, the IOC developed activations designed to reach, engage, inform, entertain, inspire and grow its fanbase worldwide – both during the “flame-to-flame” period between Games and during Games-time itself. This included amplifying partners’ own initiatives as well as co-creating fully integrated campaigns that leveraged a range of assets and capabilities, including customised content, video, social media, email communications, influencer marketing, advertising, paid media and PR.  Keeping the fans informed of every medal and record-breaking moment at Paris 2024, courtesy of Samsung and OMEGA.  edal Alerts: Samsung, and the joint M Together for Tomorrow programme, presented the medal alerts that “broke the news” on Olympics social platforms as medals were awarded.  reaking Record Alerts: Recognising B OMEGA for its role as Official Timekeeper, the IOC posted a branded animation for Olympic and world records. Preparing fans with engaging trivia quizzes and sport explainer videos so they were best-prepared for the competitions, in partnership with Allianz.  ports Explainers: Allianz was the S presenting partner of sport explainer videos for all Olympic and Paralympic disciplines, with videos hosted on Olympics.com and promoted across all digital channels during Paris 2024.   rivia: Together with Allianz, the IOC T invited audiences around the world to learn about the Games through fan engagement Olympic and Paralympic Trivia, from April through Paris 2024. Entertaining fans with branded content featuring athletes, the magic of past Games, unique behind-thescenes experiences from the Athlete Village, and highlighting the impact of Olympic “Firsts”.  agic Moments: A branded content M series with Coca-Cola that celebrated magical moments in Olympic history and during Paris 2024.  thletes for Good: A branded content A series with P&G showcasing how athletes who received grants from P&G make a positive impact and “do good” outside the field of play, while also celebrating their medals at Paris 2024.  he Starting Line: A video series T featuring 10 global Team Toyota athletes who prove that “greatness comes from anywhere” as they shared their unique"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 86,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg87.jpg",
    "zoom": null,
    "content": "\n\n\n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/tKxgJXmq1eQ?si=5ej5374Xe_he0oxp')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:525px;top:65px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Digital Engagement  Olympic journeys while representing as well as being supported by their local communities.  eloitte Firsts: A branded content series D uncovering the “First Effect”, reframing what victory looks like for humanity. It is built on the truth that winning is a win for one person, but firsts are a win for everyone. They unlock something for humanity and move the world forward. Unique and ambitious collaborations, made possible because of the IOC’s partnerships and its partners' drive to innovate, learn and enhance the fan experience.  ello World: A music-focused joint H activation with Coca-Cola that included the launch of a song for the Olympic Games, written and produced by songwriter, producer and OneRepublic frontman Ryan Tedder. Grammy Awardwinning singer-songwriter Gwen Stefani performed the single alongside eighttime Grammy Award-winning producer and singer-songwriter Anderson. Paak.  y Olympic Rewards: A pilot of a M points-and-rewards-driven platform for Olympic fans around the world, in partnership with Visa. Partners such as Intel and Samsung also activated on the platform for Paris 2024.  igital Panini sticker albums: Developed D by Panini in partnership with Coca-Cola, fans could access digital collectible sticker albums for Paris 2024.  ictory Selfie: The IOC brought the V Victory Selfie 360, from Olympics global and local social channels, amplifying the on-site product placement and athlete engagement around the medal moment.  ogether for Tomorrow – Samsung T Health: With Samsung Health and rewards on MyOlympicRewards, the IOC and Samsung launched a global challenge for Olympic fans to walk around the world between past and future Olympic Games host cities. Together, participants took 297 billion steps and circled the world more than 5,200 times.  87  Let’s Move  120m+  engagements on Olympic social handles  Official App of the Olympic and Paralympic Games Paris 2024 The official app of the Olympic and Paralympic Games Paris 2024 was an essential tool for fans worldwide, offering an all-in-one platform to stay connected with the Games. Completely redesigned for the Olympic Games Paris 2024, the app introduced a host of new features tailored to enhance the spectator experience, both for fans on the ground and for those following the action remotely. Key upgrades included improved schedules, medals and results sections, as well as a live blog that provided instant access to the latest updates. Customisable schedules, medal tables and results allowed fans to tailor their experience, while personalised push notifications ensured they never missed breaking news or results for their favourite sports, teams and athletes. The app also offered exclusive content, including original Olympic news, features and insights, alongside interactive elements such as the Olympic shop, where fans could browse and purchase official merchandise, and an Olympic trivia game that tested users’ knowledge of the Games. For those attending the Games in person, the app provided practical tools to simplify their experience. A dedicated “My Events” section enabled session management, complete with checklists  of essential venue information to ensure a seamless visit. The interactive Games map was another standout feature, guiding fans through must-see venues, fan zones and events across Paris, helping them make the most of their Olympic experience. With its comprehensive functionality and user-friendly design, the Paris 2024 Olympics app served as the ultimate companion – opened 450m times – merging information, entertainment and convenience for Olympic fans.  Let’s Move The IOC’s ongoing “Let’s Move” campaign, launched in collaboration with the World Health Organisation, encourages fans worldwide to embrace physical activity for better health. The “Let’s Move and Celebrate” initiative for Paris 2024 hoped to inspire fans to move through the Olympic Games, through Olympic Day celebrations and digital activations such as recreating iconic athlete celebration moves, and to share them on social media using #LetsMove. The campaign inspired millions of fans worldwide to move and cheer for the athletes on their road to the Olympic Games Paris 2024. With over 120 million engagements on Olympic social handles, “Let’s Move” continued to energise audiences globally, showcasing the joy and inclusivity of sport while supporting the Olympic Movement’s commitment to promoting active lifestyles."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 87,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg88.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "88  Digital Partnerships The IOC’s digital partnership collaborations for Paris 2024 redefined how fans engaged with the Games, offering a seamless blend of innovation, interactivity and storytelling. Through collaborations with 13 leading digital platforms across 27 products, the IOC was able to extend the Games’ reach, providing fans with diverse opportunities to immerse themselves in the action. Dedicated Olympic content hubs on TikTok and YouTube became must-visit destinations for fans, hosting a mix of highlights, storytelling and athlete-driven content. TikTok collectibles allowed fans to unlock rewards from Worldwide Olympic Partners, while trending videos like behind-the-scenes glimpses into the Olympic Village – including the now-famous chocolate muffins – captured global attention. Interactive experiences across Meta’s Instagram, Facebook and WhatsApp enriched fan engagement. Olympic-themed AR filters, custom backgrounds, and WhatsApp sticker packs offered creative ways for fans to connect with the Games, while curated storytelling on Instagram and Facebook also brought Paris 2024 to life. The Olympic Phryges mascot became a star of these activations, appearing in Meta experiences, games and more. For the first time, fans experienced the Games through more than 20 augmented reality (AR) activations. Available via the Olympics app, Snap, and other platforms, these experiences allowed fans to travel back to the Olympic Games Paris 1924, interact with the action at competition venues, and engage with the streets of Paris in new and immersive ways. Global search interest in the Olympic Games peaked during Paris 2024, supported by collaborations with Google and Microsoft. Fans accessed the Games via dedicated Olympic hubs, while promotional efforts on the Play Store and App Store spotlighted the official Olympics app and MRH platforms, ensuring seamless access to information and content. The IOC introduced the first-ever Olympic Creator Programme, bringing together a host of digital creators from around the world. Through partnerships with TikTok, Meta and YouTube, these creators shared diverse perspectives, telling the story of the Games in uniquely creative ways. Their engaging and authentic content captivated millions, further amplifying the reach and impact of Paris 2024.  increase in total engagements on IOC social media handles  174%  Total followers on IOC social media handles  84m  151m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 88,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg89.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Digital Engagement  89  1 in 100 Million campaign for IOC Refugee Olympic Team The IOC Refugee Olympic Team inspired millions at Paris 2024, with digital efforts  Olympic-Owned Social Media  highlighting the athletes’ extraordinary journeys. Across Olympic social platforms, the team  garnered 25 million engagements, and its social following tripled during the Games, reflecting the global admiration for these exceptional athletes.  The Olympic social media team curated an extensive content strategy to deepen fan engagement. This included social-first activations such as live scavenger hunts in Paris, interactive art installations, and collaborations with creators. Historic moments from the Olympic archive were also revisited, building anticipation and connecting the legacy of past Games with the energy of Paris 2024. Near-live sporting moments and exclusive behindthe-scenes content provided fans with real-time access to the excitement and personal stories behind the Games.  Engaging Fans in China  In the build-up and during the Olympic Games, IOC owned handles produced 45,000 posts across more than 40 accounts in seven languages, ensuring a constant stream of engaging content for a global audience. During Games time, the accounts added on average 1.6 million new followers daily, underscoring the immense reach and appeal of the Olympic Games.  In July 2024, the platform launched a dedicated Paris Games hub, providing access to medal tables, event schedules, and results, alongside unique engagement opportunities. Fans could participate in predictors, vote for their favourite moments and athletes, and explore sweepstakesstyle activities that kept them actively involved throughout the Games.  Paris 2024 became the most engaged Olympic Games on social media. The IOC’s own digital platforms and social handles generated 16.7 billion engagements, a 174 per cent increase on the previous edition of the Games Olympics social media handles added 32 million new followers for the Games period, bringing the total audience to 151 million. This recordbreaking success reflected the IOC’s strategic focus on platform-specific content that connected with diverse audiences worldwide, particularly younger generations.  Direct Marketing  Youth-focused platforms like TikTok and Instagram were key drivers of this engagement, capturing the attention of audiences through viral trends, athlete-generated content, and creative storytelling.  Personalised communication played a pivotal role in engaging fans during Olympic Games Paris 2024. The IOC delivered 450 million direct messages, including tailored newsletters and push notifications, offering real-time updates,  exclusive content, and seamless user experiences. These efforts resulted in record-breaking engagement levels through direct communications with people around the world.  The Olympics WeChat Mini Program served as a prime engagement platform for Chinese-speaking fans during Paris 2024, offering a tailored experience that combined bespoke content, real-time updates, and interactive features.  To reach new audiences and diversify content, the IOC collaborated with a host of local cultural stars. These activities, which included quizzes and challenges, added a dynamic and playful dimension to fan engagement in the region. The initiative also helped the platform acquire 1.3 million new users, further broadening the reach of the Games in China."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 89,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg90.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 90,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg91.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Ticketing and Hospitality"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 91,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg92.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 92-red-longline\" style=\"top:755px;left:-330px;\" src=\"/paris2024/static/_content/92-red-longline.png\"/>\n\n      <img class=\"abs halfScaleC 92-shortline\" style=\"top:731px;left:14px;\" src=\"/paris2024/static/_content/92-shortline.png\"/>\n      <h1 id=\"92-no\" class=\"abs olympic-HeadlineReg 92-no\" style=\"top:806px;left:35px; font-size: 1.7em; font-weight: 300; color: #c01f2b; padding: 0px; margin: 0px;\"  data-number='{\"to\": 9.5, \"decimals\": 1, \"append\": \"M\" }' ></h1>\n      <img class=\"abs halfScaleC 92-text\" style=\"top:835px;left:13px;\" src=\"/paris2024/static/_content/92-text-1.png\"/>\n      <img class=\"abs halfScaleC 92-icon\" style=\"top:711px;left:7px;\" src=\"/paris2024/static/_content/92-icon-1.png\"/>\n\n      <img class=\"abs halfScaleC 92-longline\" style=\"top:640px;left:103px;\" src=\"/paris2024/static/_content/92-longline.png\"/>\n      <h1 id=\"92-no\" class=\"abs olympic-HeadlineReg 92-no\" style=\"top:668px;left:143px; font-size: 1.7em; font-weight: 300; color: #c01f2b; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1, \"append\": \"M\" }' ></h1>\n      <img class=\"abs halfScaleC 92-text\" style=\"top:689px;left:100px;\" src=\"/paris2024/static/_content/92-text-2.png\"/>\n      <img class=\"abs halfScaleC 92-icon\" style=\"top:711px;left:101px;\" src=\"/paris2024/static/_content/92-icon-2.png\"/>\n\n      <img class=\"abs halfScaleC 92-shortline\" style=\"top:731px;left:199px;\" src=\"/paris2024/static/_content/92-shortline.png\"/>\n      <h1 id=\"92-no\" class=\"abs olympic-HeadlineReg 92-no\" style=\"top:806px;left:236px; font-size: 1.7em; font-weight: 300; color: #c01f2b; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4, \"append\": \"M\" }' ></h1>\n      <img class=\"abs halfScaleC 92-text\" style=\"top:829px;left:186px;\" src=\"/paris2024/static/_content/92-text-3.png\"/>\n      <img class=\"abs halfScaleC 92-icon\" style=\"top:711px;left:198px;\" src=\"/paris2024/static/_content/92-icon-3.png\"/>\n\n      <img class=\"abs halfScaleC 92-longline\" style=\"top:640px;left:294px;\" src=\"/paris2024/static/_content/92-longline.png\"/>\n      <h1 id=\"92-no\" class=\"abs olympic-HeadlineReg 92-no\" style=\"top:668px;left:332px; font-size: 1.7em; font-weight: 300; color: #c01f2b; padding: 0px; margin: 0px;\"  data-number='{\"to\": 6, \"append\": \"M\" }' ></h1>\n      <img class=\"abs halfScaleC 92-text\" style=\"top:683px;left:281px;\" src=\"/paris2024/static/_content/92-text-4.png\"/>\n      <img class=\"abs halfScaleC 92-icon\" style=\"top:711px;left:293px;\" src=\"/paris2024/static/_content/92-icon-4.png\"/>\n\n      <img class=\"abs halfScaleC 92-shortline\" style=\"top:731px;left:389px;\" src=\"/paris2024/static/_content/92-shortline.png\"/>\n      <h1 id=\"92-no\" class=\"abs olympic-HeadlineReg 92-no\" style=\"top:806px;left:403px; font-size: 1.7em; font-weight: 300; color: #c01f2b; padding: 0px; margin: 0px;\"  data-number='{\"to\": 280000, \"comma\": true }' ></h1>\n      <img class=\"abs halfScaleC 92-text\" style=\"top:829px;left:376px;\" src=\"/paris2024/static/_content/92-text-5.png\"/>\n      <img class=\"abs halfScaleC 92-icon\" style=\"top:711px;left:387px;\" src=\"/paris2024/static/_content/92-icon-5.png\"/>\n\n      <img class=\"abs halfScaleC 92-longline\" style=\"top:640px;left:485px;\" src=\"/paris2024/static/_content/92-longline.png\"/>\n      <h1 id=\"92-no\" class=\"abs olympic-HeadlineReg 92-no\" style=\"top:668px;left:526px; font-size: 1.7em; font-weight: 300; color: #c01f2b; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1, \"append\": \"M\" }' ></h1>\n      <img class=\"abs halfScaleC 92-text\" style=\"top:683px;left:455px;\" src=\"/paris2024/static/_content/92-text-6.png\"/>\n      <img class=\"abs halfScaleC 92-icon\" style=\"top:711px;left:481px;\" src=\"/paris2024/static/_content/92-icon-6.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n        pg92Anim = new TimelineMax();\n\n        pg92Anim.fromTo(cOf(\"92-red-longline\"), 6.5, {scaleX: 0, transformOrigin: \"left center\"}, {scaleX: 1, ease: Power2.easeOut}, 0.8)\n        .staggerFromTo(cOf(\"92-shortline\"), 0.4, {scaleY: 0}, {scaleY: 0.5, ease: Power2.easeOut}, 0.4, 1.6)\n        .staggerFromTo(cOf(\"92-icon\"), 0.4, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.8)\n        .staggerFromTo(cOf(\"92-longline\"), 0.4, {scaleY: 0}, {scaleY: 0.5, ease: Power2.easeOut}, 0.4, 2)\n        .staggerFromTo(cOf(\"92-text\"), 0.4, {opacity: 0, x: -15}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 2,2)\n        .fromTo(cOf(\"92-no\")[0], 0, {opacity: 0}, {opacity: 1, onComplete:function(){ animateNumber(cOf(\"92-no\")[0])}}, 2.3)\n        .fromTo(cOf(\"92-no\")[1], 0, {opacity: 0}, {opacity: 1, onComplete:function(){ animateNumber(cOf(\"92-no\")[1])}}, 2.5)\n        .fromTo(cOf(\"92-no\")[2], 0, {opacity: 0}, {opacity: 1, onComplete:function(){ animateNumber(cOf(\"92-no\")[2])}}, 2.7)\n        .fromTo(cOf(\"92-no\")[3], 0, {opacity: 0}, {opacity: 1, onComplete:function(){ animateNumber(cOf(\"92-no\")[3])}}, 2.9)\n        .fromTo(cOf(\"92-no\")[4], 0, {opacity: 0}, {opacity: 1, onComplete:function(){ animateNumber(cOf(\"92-no\")[4])}}, 3.1)\n        .fromTo(cOf(\"92-no\")[5], 0, {opacity: 0}, {opacity: 1, onComplete:function(){ animateNumber(cOf(\"92-no\")[5])}}, 3.3);\n        }\n\n\n        function onPageLeave() {\n        pg92Anim.stop();\n        resetNumbers(\"92-no\");\n        }\n      ",
    "searchText": "92  Ticketing and Hospitality WITH MILLIONS OF PASSIONATE FANS IN PACKED VENUES CREATING AN UNFORGETTABLE ATMOSPHERE, PARIS 2024 SIGNALLED A HUGELY SUCCESSFUL LAUNCH OF A NEW ERA FOR OLYMPIC TICKETING AND HOSPITALITY The Olympic Games Paris 2024 marked a significant milestone for the Olympic ticketing and hospitality programmes, becoming the first edition of the Games to fully implement the IOC’s new centralised model. Launched as part of the  Olympic Agenda 2020+5 reforms, this innovative approach aimed to provide fans around the world with seamless access to tickets and hospitality packages, while simplifying operations, enhancing services to stakeholders, and creating new revenue opportunities.  Record-Breaking Ticket Sales Paris 2024 set a new benchmark for ticket sales, with over 9.5 million tickets sold out of a total of 10 million available, reflecting the Games’ commitment to accessibility and inclusion. The programme prioritised affordability, with one million tickets priced at just EUR 24 and four million tickets available for EUR 50 or less, reflecting Paris 2024’s commitment to hosting accessible and affordable Games, in line with its “Games Wide Open” slogan. The significant demand for tickets was driven by a combination of attractive pricing and the new centralised ticketing platform, which provided fans from around the world with direct access to Olympic tickets at standardised prices.  1m  6m  tickets priced at €24  €  9.5m  tickets sold  1m  fans visited celebration sites across France  fans lined the streets of Paris for the cycling road race  €  4m  tickets priced at €50 or less  280,000 fans visited the Champions Park"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 92,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg93.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Ticketing and Hospitality  Unprecedented Fan Engagement and Atmosphere The overwhelming demand for tickets and hospitality packages translated into packed venues and vibrant celebrations across France, with enthusiastic fans filling the stands at competition venues and creating an electric atmosphere for athletes and spectators alike. Beyond the venues, Olympic fever spread throughout the country, with six million visitors attending celebration sites across France. The Champs-Élysées, Parc Georges-Valbon, and Marseille Club 2024 sites alone welcomed up to 20,000 people each day, offering fans the chance to engage with the Games  through live screenings, cultural activities, and special events. Fans also embraced the innovative Carrés des Supporters zones located in venue stands, where 145,000 spectators gathered to cheer for athletes, creating a festive environment and adding to the overall excitement of the Games. On the streets of Paris, nearly one million spectators turned out to watch the Olympic road cycling races along the River Seine, while the Champions Park in the shadow of the Eiffel Tower attracted 280,000 visitors to celebrate and cheer for more than 600 medallists.  93  Spectator experience ranks highly According to those surveyed, 85 per cent of Paris 2024 spectators rated their experience as “excellent” or “good” for ticketed events, with this rising to 95 per cent for the free events, and 98 per cent for the Marathon Pour Tous. “Atmosphere”, “visual appearance” an-d “security” were cited as key drivers across all events."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 93,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg94.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "94  Setting the standard for the Olympic Hospitality Experience The Paris 2024 hospitality programme set the standard for Olympic hospitality, offering fans and stakeholders a truly unique way to experience the Games. As the first Olympic Games to implement the IOC’s new global hospitality model, Paris 2024 featured an array of exclusive, ticket-inclusive travel and hospitality packages developed by On Location, the official hospitality provider for the Games. These packages catered to diverse audiences with a range of services and premium experiences.  For the first time, more than 90 per cent of Olympic sports featured dedicated hospitality offerings. Fans were able to choose from various options to suit their preferences and budgets, including: • On-Site Hospitality: High-quality, in-venue experiences within official competition venues, offering shared lounges and private boxes where guests could enjoy the sporting session of their choice while accessing premium services such as gourmet catering, private bars, and exclusive seating areas.  • In The City Hospitality: A groundbreaking concept created specifically for Paris 2024, these packages combined guaranteed tickets to Olympic events with exclusive access to iconic Parisian locations such as the Palais de Tokyo, the Eiffel Tower, and historic venues along the River Seine. These locations offered guests the opportunity to enjoy high-end food and beverages, athlete appearances, interactive activities, and cultural experiences that captured the essence of Paris and the Olympic Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 94,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg95.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Ticketing and Hospitality  • Travel Packages: Tailored to meet the needs of individual fans, families, and corporate clients, the travel packages included tickets to the Games along with accommodation, transport options, guided tours, and exclusive hospitality experiences. These offerings allowed guests to immerse themselves fully in the Olympic experience, making their trip to Paris a once-in-a-lifetime event. In addition to these core packages, Paris 2024’s hospitality programme also featured bespoke options for corporate clients and large groups, providing the flexibility to customise experiences and create unforgettable memories for business partners, employees, and VIP guests.  “Paris 2024 revolutionised the delivery of Olympic Games hospitality, opening up hospitality packages to a larger global audience than ever before, from individuals to corporate clients.” 	 Louise Dier, Director of Hospitality, Paris 2024  A key feature of this programme was the use of the centralised online hospitality platform operated by On Location, which streamlined the purchasing process and provided fans with a single, secure source for all ticket and hospitality needs. The platform, along with a network of official sub-distributors, ensured that every fan had access to authentic hospitality experiences, helping to safeguard against the risks of unauthorised ticket sales and reselling. To further enhance the hospitality experience, the Olympic Museum loaned On Location artefacts and provided content and expertise on exhibition development, curation, and design, as well as visitor experience. The museum played a pivotal role in the project during Paris 2024, dedicating significant resources and expertise to enhance the Olympic Games experience. The Olympic Museum and its artifacts greatly enriched guest experiences across the various Paris 2024 hospitality venues, operated by On Location, where they were showcased.  95  Setting New Standards for Future Games The success of the Paris 2024 ticketing and hospitality programmes not only generated substantial revenue but also set a new benchmark for future Games. By providing a wide range of innovative hospitality offerings, Paris 2024 redefined what it means to experience the Olympic Games, ensuring that fans, stakeholders, and partners enjoyed a memorable journey that extended far beyond the competition venues. The implementation of this centralised model will continue to benefit future Games editions, establishing a consistent and high-quality hospitality experience that enhances the value of the Olympic brand.  NOC Houses: Immersive fan experiences In addition to the excitement of the competition venues, fans at Paris 2024 were treated to the vibrant atmosphere of 37 National Olympic Committee (NOC) Houses across the city, with 31 open to the public and 12 located at La Villette Park, which became known as “Nations Park” during the Games. These vibrant spaces allowed fans to celebrate with Olympic teams, enjoy cultural showcases, and experience unique fan activations. Several NOCs also partnered with TOP Partners, creating engaging activations that showcased innovation and further enhanced the fan experience."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 95,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg96.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Licensing and Merchandising"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 96,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg97.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 97,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg98.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "98  xxx  Licensing and Merchandising THE LICENSING PROGRAMMES FOR THE OLYMPIC GAMES PARIS 2024 WERE AN OVERWHELMING SUCCESS, CAPTURING THE ENTHUSIASM OF MILLIONS OF FANS BOTH IN FRANCE AND AROUND THE WORLD. With over 8,000 officially licensed products available, fans of the Olympic Games Paris 2024 had an extensive range of souvenirs to choose from. From the ever-popular mascots and collectible pins to clothing, accessories, stationery and homewares, the Paris 2024 Organising Committee’s licensing programme truly offered something for everyone.  The wide array of merchandise, sold at 150 official shops and 30,000 points of sale across France, and internationally via the online Olympic Shop, allowed fans to take home a piece of Paris 2024, while generating vital revenue to support the Games. Official merchandise was offered at a price range to suit all budgets, with items ranging from €5 for a selection of pens,  bracelets and notebooks, to €800 for a giant plush made in France. The programme not only celebrated the unique identity of Paris 2024 but also highlighted the Organising Committee’s commitment to sustainability and local craftsmanship, with 90 per cent of licensees being French small and medium-sized enterprises (SMEs)."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 98,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg99.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:351px;left:147px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 8000, \"comma\": true }' ></h1>\n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:411px;left:111px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30000, \"comma\": true }' ></h1>\n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:477px;left:125px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 150 }' ></h1>\n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:547px;left:136px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1, \"append\": \"M\" }' ></h1>\n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:633px;left:118px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 300000, \"comma\": true }' ></h1>\n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:698px;left:180px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3.3, \"decimals\": 1, \"append\": \"M\" }' ></h1>\n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:765px;left:251px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 78}' ></h1>\n      <h1 id=\"99-no\" class=\"abs olympic-HeadlineReg 99-no\" style=\"top:818px;left:304px; font-size: 1.3em; font-weight: 300; color: #f8f8f8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 90, \"append\": \"%\" }' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        pg99Anim = new TimelineMax();\n        pg99Anim.fromTo(cOf(\"99-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[0])}}, 1.0)\n        pg99Anim.fromTo(cOf(\"99-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[1])}}, 1.1)\n        pg99Anim.fromTo(cOf(\"99-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[2])}}, 1.2)\n        pg99Anim.fromTo(cOf(\"99-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[3])}}, 1.3)\n        pg99Anim.fromTo(cOf(\"99-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[4])}}, 1.4)\n        pg99Anim.fromTo(cOf(\"99-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[5])}}, 1.5)\n        pg99Anim.fromTo(cOf(\"99-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[6])}}, 1.6)\n        pg99Anim.fromTo(cOf(\"99-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"99-no\")[7])}}, 1.7)\n        }\n\n        function onPageLeave() {\n        pg99Anim.stop();\n        resetNumbers(\"99-no\");\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Licensing and Merchandising  “We've got 'pin mania' back in full force for this edition of the Games. The products are flying off the shelves.” Etienne Thobois, CEO, Paris 2024  99  The enthusiasm for official merchandise was evident throughout the Games, with hordes of fans flocking to flagship stores at iconic locations such as the megastore situated on the Champs-Élysées, which attracted more than one million visitors. The official Paris 2024 mascots – the Phryges – were particularly popular, with 3.3 million plush toys sold. The wide array of collectible pins and the official posters – including the limited edition night version available online only – were also highly sought after, becoming must-have items for many visitors.  The stunning collection of 250 coins, produced by Monnaie de Paris, included, amongst other values, commemorative €2 coins in gold and silver. For the first time ever, Monnaie de Paris also produced coins with a hexagonal design, reflecting the shape of France itself. In total, seven million coins were sold.  In keeping with Olympic tradition, the Paris 2024 licensing programme also extended to commemorative coins and stamps, which paid tribute to the host city’s iconic monuments as well as celebrating the look of the Games.  With its diverse range of products and a strong focus on local production and sustainability, the Paris 2024 licensing programme was a resounding success, creating a memorable experience for fans and a lasting legacy for the Games.  8,000  different products available  30,000  points of sale throughout France  150  official shops throughout France  1m  visitors to the megastore on the Champs-Elysées  300,000  official posters sold  3.3m  mascot plush toys sold  78  licensees appointed by Paris 2024  90%  of licensees were French SMEs  Meanwhile, the official Paris 2024 stamp, released by La Poste, featured a design showcasing the Games’ visual identity and iconic Parisian sights, with more than one million being sold."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 99,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg100.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "100  IOC Global Licensing Programme Beyond the Paris 2024 licensing programme, the IOC also launched a global licensing initiative for the Games, featuring a wide range of physical and digital products. Collaborating with several new licensees, these Olympic-branded products were released across three collections: the Olympic Games Collection, which promotes the Games globally; the Olympic Heritage Collection, which celebrates the art and design of past Olympic Games; and the Olympic Collection, which helps bring the Olympic values to sports fans and young people globally. The Olympic Games Collection items sold globally included Paris 2024 match and  replica balls for volleyball, beach volleyball and water polo (all produced by Mikasa) and basketball and handball (produced by Molten), as well as Paris 2024 finger skateboards and ramps, developed with Spin Master’s Tech Deck brand, enabling fans to create their own Olympic skateparks. In addition, new apparel items within the Olympic Collection were released in cooperation with Trendyol, an affiliate of TOP Partner Alibaba, while fans were also able to purchase a range of co-branded Looney Tunes merchandise, developed in collaboration with Warner Bros. Discovery Global Consumer Products, including apparel, pins and accessories available on the online Olympic Shop and a limited collection available at Pull& Bear stores.  “Official merchandise enables fans to connect with the Olympic and Paralympic Games and collect their own special piece of Olympic history.”  nne-Sophie Voumard, A Managing Director of IOC Television & Marketing Services"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 100,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg101.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('/paris2024/static/_content/pg101-vid.mp4')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:522px;top:92px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>\n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/yhcPryGi5tM?si=J-ujI2o1nIgOYX2n')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:45px;top:460px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>\n  \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Licensing and Merchandising  101  Digital offerings connecting with fans globally Fans around the world were also given the chance to connect with the Games via a wide range of digital offerings that provided interactive Olympic experiences. These included OlympicsTM Go! Paris 2024, the official mobile game for the Olympic Games Paris 2024, published by nWay and downloaded by two million fans; digital pins that were minted and distributed to 270,000 fans by nWAY; Paris 2024 online sailing races developed by and available on Virtual Regatta; and the Olympic World – an immersive environment on Roblox that provided a dynamic new platform to engage more than 11 million young people. Olympic fans were also inspired to test themselves in a variety of connected sports challenges available via the Kinomap interactive training app. These unique offerings gave runners, cyclists and rowers around the world the chance to tackle the Olympic courses remotely on their compatible home fitness equipment. For the first time, a digital and physical collectable album was also released for the Olympic Games, with the IOC collaborating with Panini and IOC TOP partner The Coca Cola Company to create a collection of digital and physical card packs for Paris 2024.  Marking 100 years since Paris 1924 In addition to products celebrating the Olympic Games Paris 2024, the IOC also worked with licensees to create products to mark the centenary of the Olympic Games Paris 1924. Offered as part of the Olympic Heritage Collection, these included a limited-edition range of apparel from Lacoste, a commemorative coin developed with the Monnaie de Paris, and special-edition Montblanc writing instruments and dedicated inks and notebooks celebrating the Olympic Games Paris 1924 and Olympic Winter Games Chamonix 1924."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 101,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg102.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE OLYMPIC BRAND"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 102,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg103.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 103,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg104.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "104  More than  3 out of 4 PEOPLE BELIEVE THAT THE OLYMPIC GAMES ARE EVEN MORE IMPORTANT IN A DIVIDED WORLD"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 104,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg105.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  The Olympic Brand  105  “The independent surveys demonstrate that people believe that the Olympic Movement’s mission to unite the world in peaceful competition is more important than ever in a divided world; and that the Olympic values truly resonate with younger generations.” Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 105,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg106.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/v5GcJWnC_xM?si=3DGxRE5lcJHGosmQ')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:26px;top:786px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "106  THE OLYMPIC BRAND WITH EACH EDITION OF THE GAMES, THE OLYMPIC BRAND GROWS STRONGER, ENRICHED BY THE UNIQUE IDENTITY OF EACH HOST CITY. AT PARIS 2024, IT BLENDED THE TIMELESS SYMBOLISM OF THE OLYMPIC RINGS WITH THE ELEGANCE AND CREATIVITY OF FRANCE The Olympic rings are one of the most recognised symbols in the world, and during the Olympic Games Paris 2024, their enduring appeal was on full display. Towering over the French capital, a giant set of Olympic rings was installed on the iconic Eiffel Tower, measuring 29 meters wide and 13 meters high, and weighing 30 tonnes. Suspended between the first and second floors – approximately 60 metres above the ground – these huge rings became one of Paris’s most photographed sights, standing as a stunning testament to the unifying power of the Games, drawing locals and visitors alike to capture the moment and celebrate the Olympic spirit. For athletes, the Olympic rings were just as iconic and personal. No stay in Paris was complete without posing for a selfie in front of the Olympic Village’s own set of rings – a symbol of their participation in the Games and the realisation of their Olympic dreams. These images, shared widely on social media, reinforced the rings’ timeless appeal and their role in creating unforgettable memories for athletes and fans alike.  Very few symbols can inspire such universal recognition and emotional connection. Yet the Olympic rings transcend sport, embodying the values of excellence, friendship and respect. First designed by Pierre de Coubertin over a century ago, they represent the unity of the five continents in peaceful competition. Independent research commissioned by the IOC confirms their extraordinary reach, with nine out of ten people worldwide able to identify the rings. Beyond their symbolic significance, the Olympic rings are integral to the commercial success of the Olympic Movement. Their universal recognition attracts global partners eager to align with the positive values and extensive reach of the Games, enabling the IOC to continue inspiring the world through sport.  “W hen you enter the track and you see those five rings, that's goosebumps.”  Independent surveys conducted on behalf of the IOC have revealed that people believe that the Olympic Movement’s mission to unite the world in peaceful competition is more important than ever, and that the Olympic values truly resonate with younger generations. In consumer insight studies, 78 per cent of those surveyed said they believed the Olympic Games are more important than ever in a divided world, while three out of four also believed that the IOC was successful in “bringing the world together in peaceful competition” and in “building a better world through sport”. According to an independent brand tracker study conducted in September 2024, the relevance of the Olympic Games for Gen Z is now higher than for the general population, including outperforming other demographic groups in the metrics of “engagement with the Olympics”, “brand affinity” and “brand relevance”. This was driven in particular by the “inspiring stories of the athletes”, the “buzz on social media” and “improved accessibility to content”.  	 Julie Nicolaes (BEL, cycling)  The Olympic Symbol Designed by Baron Pierre de Coubertin in 1913  The relevance of the Olympic Games and the Olympic brand  First shown on an Olympic flag in 1914  Visual representation of Olympism Interlinked rings show how athletes come together at the Games Rings represent the five continents of the world Can be identified by 9 out of 10 people globally"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 106,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg107.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  The Olympic Brand  107  The Olympic Rings & The Eiffel Tower  Illuminated by 100,000 low-intensity LEDs  Weighed approximately 30 tonnes  13  29  metres High  metres wide  “We wanted the most iconic symbol of the Olympics – the rings – to meet the most iconic symbol of Paris – the Eiffel Tower.” Michaël Aloïsio, Managing Director, Paris 2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 107,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg108.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "108  THE PARIS 2024 BRAND While the rings provide continuity from one Olympic Games to the next, each edition also introduces its own unique brand identity, reflecting the culture, character, and vision of the host city and nation.  Paris 2024 embraced the spirit of innovation and heritage, creating a brand identity that celebrated the 'French art de vivre' while highlighting inclusivity, sustainability, and the pursuit of excellence.  US gymnast Simone Biles added to her incredible Olympic legacy with four more medals, including team, vault and all-around gold"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 108,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg109.jpg",
    "zoom": null,
    "content": "\n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/08aeo0WZMOY?si=JUzczBfBslKKjYxi')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:156px;top:54px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>  \n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/ccrHmiad6XA?si=mmZR0jxzhJEZ6Ald')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:346px;top:54px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>  \n\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/TdDN-vJmCdM?si=XRSPRhleqwhRCi50')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:536px;top:54px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>  \n\n       <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/kHELBhAyBZk?si=acbAk_olxKYCEeDD')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:156px;top:494px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a> \n     \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/mhsYRlQrt1o?si=Eu2oNEoESz2kKwBe')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:536px;top:494px\" src=\"/paris2024/static/_content/play-black.png\">\n      </a>  \n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  The Olympic Brand  109  • Look of the Games Unveiled in February 2023, the Look of the Games featured bold, colourful designs inspired by the iconic paving stones found throughout Paris and France. These geometric shapes symbolised the host nation’s heritage while offering endless customisation possibilities for communities and partners. For the first time, a unified Look was created for both the Olympic and Paralympic Games, reducing both costs and environmental impact.  • Emblem The Paris 2024 emblem, launched in October 2019, brought together the gold medal, Olympic flame and Marianne – a symbol of liberty and French identity. With its feminine design, the emblem commemorated the Olympic Games Paris 1900, where women competed for the first time, and was shared by both the Olympic and Paralympic Games.  • Medals Crafted by Chaumet, a prestigious French jeweller, the Paris 2024 medals featured 18 grams of iron sourced from the Eiffel Tower, embodying the Games’ connection to France’s heritage. The medal design incorporated a hexagon, symbolising France, with fine lines radiating outward to represent the brilliance of athletic achievement.  • Mascots Unveiled in November 2022, “The Phryges” mascots took inspiration from the Phrygian caps, a symbol of freedom rooted in French revolutionary history. These mascots reflected Paris 2024’s vision of inspiring change through sport and became a beloved representation of the Games.  • Olympic Torch Designed by French artist Matthieu Lehanneur, the Paris 2024 Olympic Torch combined concepts of equality, water and peace. Its symmetrical design reflected balance and harmony, while ripples along its surface evoked the River Seine.  • Pictograms Paris 2024 reimagined the Olympic pictograms, elevating them into striking coats of arms representing each sport. These 62 unique designs served as badges of honour for athletes and fans, symbolising pride, belonging and the values of each sports discipline."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 109,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg110.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "110  PRESERVING THE COMMERCIAL VALUE OF THE OLYMPIC BRAND  The Olympic rings are among the most recognised symbols in the world, and their universal appeal lies at the heart of the IOC’s marketing programmes, which offer commercial partners an exclusive association with this iconic emblem. This unique partnership ensures that the Olympic Games can be delivered to the highest standard while promoting sport worldwide. Unauthorised use of the Olympic rings and other Olympic properties1 – known as ambush marketing2 – threatens the integrity of the Olympic brand. Such actions diminish the value of official partnerships, jeopardising the revenue generated to support  athletes and sports organisations globally. Protecting the commercial value of the Olympic brand is therefore essential to safeguarding the future of the Olympic Movement. The IOC works closely with National Olympic Committees (NOCs), Organising Committees for the Olympic Games (OCOGs), and local governments to educate businesses and stakeholders about the importance of official partnerships and the harm caused by ambush marketing. Each infringement is reviewed individually, with the IOC and its partners taking appropriate action to maintain the integrity of the brand and the investment of its partners.  1 Olympic properties (as defined by the Olympic Charter) include without limitation the Olympic symbol, flag, motto, anthem, identifications (including but not limited to “Olympic Games” and “Games of the Olympiad”), designations, emblems, mascots, flame, torches, images and/or terminology, and any and all rights derived from the Olympic Games and/or the Youth Olympic Games. 2 Direct and/or indirect unauthorised association with, exploitation or promotion of, the Olympic properties and/or the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 110,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg111.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  The Olympic Brand  Paris 2024 Brand Protection Programme As part of the agreement to host the Olympic Games, the Paris 2024 Organising Committee and the French government committed to protecting all Olympic-related intellectual properties in accordance with the Olympic Charter. These properties, including emblems, logos, and designations, were safeguarded under French national law, ensuring that their use was strictly controlled and authorised only by the Paris 2024 Organising Committee. The IOC and Paris 2024 implemented a global Brand Protection Programme to uphold the integrity of these intellectual properties and preserve the value of the Olympic brand. This comprehensive programme included: • Monitoring the Internet: Dedicated teams used advanced technologies to identify and address unauthorised use of Olympic properties online, including illegal streaming and unlicensed merchandise.  111  The programme aimed to detect and act against any infringement, ensuring the exclusivity of the Olympic brand. • Collaborating with Law Enforcement: The Paris 2024 Organising Committee worked closely with law enforcement agencies to combat counterfeit goods. These efforts protected the official merchandise and ensured that consumers received authentic products while supporting the Games’ licensed suppliers. • Maintaining Compliance: By overseeing the use of intellectual properties, the programme upheld the commitments made to the IOC by Paris 2024 and safeguarded the investments of official partners. The Paris 2024 Brand Protection Programme played a vital role in defending the commercial and symbolic value of the Olympic Games. Its success ensured that the revenue generated by official partnerships could continue to support the athletes, sports organisations, and the Olympic Movement as a whole.  Global Broadcast and Internet Monitoring The global broadcast of the Olympic Games Paris 2024 relied on the exclusive rights granted to Media Rights-Holders (MRHs). Protecting these rights was a priority for the IOC, as illegal streaming and unauthorised use of audiovisual content poses significant threats to the value of the partnerships. The IOC’s Internet Monitoring Programme (IMP) used cutting-edge technology to prevent and track online violations, particularly live streaming infringements. The programme targeted illegal content across websites, social media platforms, and mobile applications, taking swift action to ensure that viewers accessed the Games through official channels. In addition to enforcement, the IOC and MRHs conducted promotional campaigns to inform audiences worldwide where, when, and how to watch official coverage of the Games. These efforts not only enhanced viewership but also acted as a powerful deterrent against piracy."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 111,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg112.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ACKNOWLEDGEMENTS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 112,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg113.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 113,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg114.jpg",
    "zoom": null,
    "content": "      \n      \n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/6c9hFGtSUF8?si=LZYuhoHcnXRSm7IE')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:42px;top:168px\" src=\"/paris2024/static/_content/play-white.png\">\n      </a>  \n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“The IOC is proud and grateful to work together with such a dedicated community of commercial partners. Their commitment ensures the Olympic Games continue to inspire and unite globally. And beyond the Olympic Games, they fuel our mission to make the world a better place through sport..” Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 114,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg115.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Acknowledgements  115  Media Rights-Holders • Albavision-Televideo  • International Media Content  • SBS  • America Movil  • IMG  • Sky Network  • beIN  • Infront  • Supersport  • Caracol  • Japan Consortium  • Telerebelde  • CBC / Radio-Canada  • LiveMode  • Televisa  • Chilevision  • NBCUniversal  • TVES  • China Media Group  • Nine  • TV Publica Argentina  • Dentsu  • Prodena  • Viacom18  • Grupo Globo  • SABC  • Warner Bros. Discovery  Worldwide Olympic Partners  Paris 2024 Premium Partners"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 115,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg116.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "116  Paris 2024 Official Partners • Groupe ADP  • Decathlon  • Air France  • FDJ  • ArcelorMittal  • GL Events Group  • Caisse des Dépôts  • Ile-de-France Mobilités  • Cisco  • Le Coq Sportif  • CMA CGM Group  • PwC  • Danone"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 116,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg117.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Acknowledgements  117  Paris 2024 Official Supporters • Abatable  • Groupe RATP  • RGS Events  • ABEO  • Highfield  • Saint-Gobain  • Air Liquide  • Hype  • Salesforce  • Airweave  • Indigo  • SCC  • Aquatique Show  • La Poste  • Schneider Electric  • Arena  • Loxam  • SLX  • CRYSTAL  • Lyreco  • SNCF  • Doublet Wasserman  • Miko  • Sodexo Live!  • DXC Technology  • Mondo  • Egis  • MTD  • Syndicat des Eaux d'Île-de-France  • Enedis  • Myrtha Pools  • ES Global  • OnePlan  • Eviden  • Optic 2000  • Fitness Park  • Ottobock  • Fnac Darty  • Randstad  • Garden Gourmet  • Rapiscan Systems  • Gerflor  • Re-uz  • Technogym • Terraillon • Thermo Fisher Scientific • Tourtel Twist • VINCI • Viparis • Westfield"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 117,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg118.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "118  EDITORIAL, DESIGN AND PRODUCTION IOC Touchline  PHOTOGRAPHY IOC Images Paris 2024 Getty Images  RESEARCH  The brand tracker, broadcast research, and consumer and athlete surveys were conducted by Nielsen, Ipsos and Publicis Sport & Entertainment. Across all consumer studies a total of more than 55,000 people in 18 countries were surveyed, with all respondents aged between 13 and 65. International Olympic Committee Maison Olympique, 1007 Lausanne, Switzerland Tel: +41 (0) 21 621 6111 www.olympics.com/ioc © This publication may not be reproduced, even in part, in any form, without the written permission of the IOC. All reproduction, translation and adaptation rights are reserved for all countries."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 118,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg119.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC Marketing Report Paris 2024  Acknowledgements  THANKS TO OUR WORLDWIDE OLYMPIC PARTNERS  119"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 119,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg120.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "International Olympic Committee  Maison Olympique, 1007 Lausanne, Switzerland www.ioc.org"
  }]],
  "script": "\n    function idOf(id) {\n      return document.getElementById(id)\n    }\n\n    function cOf(klass) {\n      return document.getElementsByClassName(klass)\n    }\n    \n    function removeContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) { \n        return e.className = 'addContentLink'\n      })\n    }\n\n    function addContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) {\n        return e.className = 'contentLink addContentLink'\n      })\n    }\n\n    function showOverlay(idx) {\n      idOf(idx).className = 'contentOverlay visible'\n    }\n\n    function hideOverlay(idx) {\n      idOf(idx).className = 'contentOverlay hidden noclick'\n    }\n\n    function animateNumber(element){\n      if(element.getAttribute(\"data-number\")){\n        var args = JSON.parse(element.getAttribute(\"data-number\"));\n        var from = 0;\n        var to = 100;\n        var append = \"\";\n        var preppend = \"\";\n        var decimals = 0;\n        var duration = 1;\n        var ease = \"Linear.easeNone\";\n        var comma = false;\n        var separator = \",\";\n        var decChar = \".\";\n        for(obj in args){\n          if(obj == \"from\") from = args[obj];\n          if(obj == \"to\") to = args[obj];\n          if(obj == \"append\") append = args[obj];\n          if(obj == \"preppend\") preppend = args[obj];\n          if(obj == \"decimals\") decimals = args[obj];\n          if(obj == \"duration\") duration = args[obj];\n          if(obj == \"ease\") ease = args[obj];\n          if(obj == \"comma\") comma = args[obj];\n          if(obj == \"separator\") separator = args[obj];\n          if(obj == \"decChar\") decChar = args[obj];\n        }\n        var obj = {number: from}\n        TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n          if(comma){\n            console.log(obj.number)\n            var str = obj.number.toFixed(decimals).toString();\n            var predec = str.split(/^d*/)[0];\n            console.log(\"PREDEC\", predec, typeof(predec));\n            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n            var comp = newstr.replace(/^,/, '')\n            console.log(\"NEWSTR\", newstr, typeof(newstr));\n            // console.log({newstr})\n            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n            // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n            var dp = \"\";\n            element.innerHTML = preppend+comp+dp+append;\n          }else{\n            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n          }\n        }, ease: eval(ease)});\n      }else{\n        return;\n      }\n    }\n\n    function resetNumbers(ele){\n      var numbers = cOf(ele)\n      for(var i=0; i<numbers.length; i++) {\n        numbers[i].innerText= \"\"\n      }\n    }\n\n    function mailChimpSubmit(){\n      $('#mc-embedded-subscribe-form').submit(function (e) {\n        var that = $(this);\n        var mailchimpSubmit = $(this).find('input[type=submit]');\n        var errorResponse = $('#mce-error-response');\n        var successResponse = $('#mce-success-response');\n\n        e.preventDefault();\n\n        $.ajax({\n          method: 'GET',\n          url: that.attr('action'),\n          data: that.serialize(),\n          dataType: 'jsonp',\n          success: function(data) {\n            console.log('AJAX SUCCESS')\n          // If there was an error then show the error message.\n            if (data.result === 'error') {\n              console.log('AJAX ERROR')\n              // If the error has an error code at front then alter the message to not include the error code and hyphen.\n              if(data.msg.indexOf('0') === 0) {\n                data.msg = data.msg.slice(3);\n              }\n              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);\n            }\n            // If success then show message\n            else {\n              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);\n            }\n          }\n        });\n      });\n    }\n  ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-7DBG1R67HY" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hRj/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mw9Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ugbl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d29a0b4f13af9230244c.js